
export const questions = {
  "1, Introduction to Gerontology (Part 1)": [
    {
      id: 90001,
      question: "According to the required reading, which chapter of Darby & Walsh covers 'The Older Adult'?",
      options: [
        "Chapter 55",
        "Chapter 47",
        "Chapter 58",
        "Chapter 12"
      ],
      correctAnswer: 1
    },
    {
      id: 90002,
      question: "What is the main driver of the professional development need described for dental hygienists regarding the elderly population?",
      options: [
        "Demographic projections showing an increase in the elderly population",
        "A shortage of geriatric dentists nationwide",
        "New insurance billing codes for older adults",
        "A decline in dental school enrollment"
      ],
      correctAnswer: 0
    },
    {
      id: 90003,
      question: "What is identified as the primary cause of the significant demographic increase in the older adult population?",
      options: [
        "Higher birth rates among older adults",
        "Increases in life expectancy",
        "Reduced immigration of younger workers",
        "Improved dental insurance coverage"
      ],
      correctAnswer: 1
    },
    {
      id: 90004,
      question: "What term describes the generation shown as reaching older adulthood and driving demographic change in the slides?",
      options: [
        "Baby Boomers",
        "Generation X",
        "The Silent Generation",
        "Millennials"
      ],
      correctAnswer: 0
    },
    {
      id: 90005,
      question: "Regarding gender differences in the older adult population, which statement is accurate?",
      options: [
        "Elderly men outnumber elderly women and are more likely to be widowed",
        "Men and women are equally represented with similar widowhood rates",
        "Elderly men are more likely to live alone than elderly women",
        "Elderly women outnumber elderly men and are more likely to be widowed"
      ],
      correctAnswer: 3
    },
    {
      id: 90006,
      question: "Which term refers to the branch of medicine concerned with the illnesses of old age and their treatment?",
      options: [
        "Gerontology",
        "Functional age",
        "Geriatrics",
        "Chronologic age"
      ],
      correctAnswer: 2
    },
    {
      id: 90007,
      question: "Which term refers to the scientific study of the factors affecting the normal aging process and the effects of aging?",
      options: [
        "Geriatrics",
        "Gerontology",
        "Gerontologist",
        "Chronologic age"
      ],
      correctAnswer: 1
    },
    {
      id: 90008,
      question: "How is 'functional age' best defined based on the slide content?",
      options: [
        "Age based on performance capacities",
        "Age as measured by calendar time since birth",
        "Age determined by dental records",
        "Age estimated from bone density scans"
      ],
      correctAnswer: 0
    },
    {
      id: 90009,
      question: "How is 'chronologic age' best defined based on the slide content?",
      options: [
        "Age based on performance capacities",
        "Age based on self-reported health status",
        "Age as measured by calendar time since birth",
        "Age determined by cognitive testing"
      ],
      correctAnswer: 2
    },
    {
      id: 90010,
      question: "According to the slides, characterizations of age for healthcare purposes should be based primarily on what?",
      options: [
        "Functional ability rather than chronologic age",
        "Chronologic age rather than functional ability",
        "Insurance category rather than either age type",
        "Retirement status rather than either age type"
      ],
      correctAnswer: 0
    },
    {
      id: 90011,
      question: "Which three categories of theories are presented to explain why and how people age?",
      options: [
        "Nutritional theories, genetic theories, and economic theories",
        "Behavioral theories, dental theories, and environmental theories",
        "Social theories, physiologic aspects, and biologic theories",
        "Cognitive theories, hormonal theories, and cultural theories"
      ],
      correctAnswer: 2
    },
    {
      id: 90012,
      question: "In a functional health assessment, activities such as bathing, dressing, toileting, transferring, feeding, and continence are classified as what?",
      options: [
        "Instrumental activities of daily living (IADLs)",
        "Chronic condition indicators",
        "Activities of daily living (ADLs)",
        "Nutritional risk indicators"
      ],
      correctAnswer: 2
    },
    {
      id: 90013,
      question: "Using the phone, preparing meals, and managing money are examples of which category of functional assessment?",
      options: [
        "Activities of daily living (ADLs)",
        "Katz dependence scoring",
        "Oral hygiene aids",
        "Instrumental activities of daily living (IADLs)"
      ],
      correctAnswer: 3
    },
    {
      id: 90014,
      question: "In the Katz Index of Independence in Activities of Daily Living, what score indicates that a patient is fully independent?",
      options: [
        "A score of 0",
        "A score of 3",
        "A score of 10",
        "A score of 6"
      ],
      correctAnswer: 3
    },
    {
      id: 90015,
      question: "Which group of conditions is identified as the leading chronic conditions in older adults?",
      options: [
        "Arthritis, hypertension and heart disease, cancer, diabetes, and respiratory disorders",
        "Migraines, allergies, insomnia, anxiety, and skin conditions",
        "Hearing loss, vision loss, dental caries, gout, and anemia",
        "Osteoporosis, ulcers, thyroid disease, gallstones, and eczema"
      ],
      correctAnswer: 0
    },
    {
      id: 90016,
      question: "Per the Canadian data shown in the slides, approximately what percentage of Canadian seniors reported having one or more of the 11 listed chronic conditions?",
      options: [
        "About 40%",
        "About 55%",
        "About 95%",
        "About 76%"
      ],
      correctAnswer: 3
    },
    {
      id: 90017,
      question: "According to Healthy People 2030 findings referenced in the slides, how do older adults compare to the general population regarding health behaviors?",
      options: [
        "Older adults take worse care of their health than the general population does",
        "Older adults show no difference in health behaviors compared to the general population",
        "Older adults take better care of their health than the general population does",
        "Older adults report higher smoking rates than younger adults"
      ],
      correctAnswer: 2
    },
    {
      id: 90018,
      question: "Which dental/periodontal change in older adults involves cracks in the enamel surface?",
      options: [
        "Secondary dentin formation",
        "Pulp calcification",
        "Acquired lamellae",
        "Atrophic glossitis"
      ],
      correctAnswer: 2
    },
    {
      id: 90019,
      question: "Obturation in the dentinal tubules is a description of which age-related dental change?",
      options: [
        "Acquired lamellae",
        "Secondary dentin formation",
        "Pulp calcification",
        "Arrested caries"
      ],
      correctAnswer: 1
    },
    {
      id: 90020,
      question: "What has been the most significant change in older adults' oral status over the past century regarding tooth loss?",
      options: [
        "A decline in total tooth loss (edentulousness)",
        "A steady increase in total tooth loss (edentulousness)",
        "No measurable change in edentulousness rates",
        "A rise in tooth loss due to increased caries"
      ],
      correctAnswer: 0
    },
    {
      id: 90021,
      question: "According to the slides, does normal aging alone cause changes in the oral mucosa?",
      options: [
        "Yes, aging alone directly causes oral mucosal changes",
        "No, aging alone does not lead to changes in oral mucosa",
        "Yes, but only in male patients",
        "Yes, but only after age 90"
      ],
      correctAnswer: 1
    },
    {
      id: 90022,
      question: "A nutritional deficiency causing anemia can produce which tongue condition described in the slides?",
      options: [
        "Burning tongue syndrome",
        "Atrophic glossitis",
        "Sublingual varicosities",
        "Angular cheilitis"
      ],
      correctAnswer: 1
    },
    {
      id: 90023,
      question: "According to the slides, is a reduction in salivary flow a normal result of the aging process?",
      options: [
        "Yes, it is a normal and expected result of aging",
        "Yes, but only in edentulous patients",
        "No, it is not a result of the normal aging process",
        "Yes, but only in patients over 100 years old"
      ],
      correctAnswer: 2
    },
    {
      id: 90024,
      question: "Which condition described in the slides is an autoimmune disorder of the salivary glands involving dry oral mucosa and ropy saliva?",
      options: [
        "Atrophic glossitis",
        "Angular cheilitis",
        "Sjögren's syndrome",
        "Gingival hyperplasia"
      ],
      correctAnswer: 2
    },
    {
      id: 90025,
      question: "Which drugs are specifically named in the slides as potentially causing drug-induced gingival enlargement?",
      options: [
        "Phenytoin, nifedipine, and cyclosporine",
        "Ibuprofen, acetaminophen, and aspirin",
        "Amoxicillin, penicillin, and clindamycin",
        "Insulin, metformin, and warfarin"
      ],
      correctAnswer: 0
    },
    {
      id: 90026,
      question: "When positioning a client with mobility concerns in the dental hygiene process of care, where should the dental chair be positioned relative to the client's knees?",
      options: [
        "At the level of the client's knees or higher",
        "Below the level of the client's knees",
        "At the level of the client's shoulders",
        "It does not matter as long as the armrest is up"
      ],
      correctAnswer: 0
    },
    {
      id: 90027,
      question: "When communicating with an older adult client, who should the dental hygienist address directly according to the slides?",
      options: [
        "The family member or caregiver, rather than the client",
        "The older adult client, rather than the family member or caregiver",
        "Whoever answers first, regardless of role",
        "Only the client's physician"
      ],
      correctAnswer: 1
    },
    {
      id: 90028,
      question: "Why might scheduling short morning appointments be recommended for older adult clients?",
      options: [
        "Because older adults prefer evening appointments generally",
        "Because morning appointments require no medical history review",
        "Because insurance only reimburses morning visits",
        "Because factors such as arthritis may limit mouth opening and clients may tire more easily"
      ],
      correctAnswer: 3
    },
    {
      id: 90029,
      question: "Which of the following is listed among the conditions requiring alterations in dental hygiene care for older adults?",
      options: [
        "Common cold",
        "Seasonal allergies",
        "Mild dehydration",
        "Congestive heart failure"
      ],
      correctAnswer: 3
    },
    {
      id: 90030,
      question: "In the implementation phase of care for older adults, what change is recommended regarding maintenance therapy?",
      options: [
        "More frequent maintenance therapy with shorter appointments for quadrant scaling",
        "Less frequent maintenance therapy with longer full-mouth appointments",
        "Elimination of maintenance therapy after age 75",
        "Maintenance therapy only during hospital visits"
      ],
      correctAnswer: 0
    },
    {
      id: 90031,
      question: "What should be done for a client with hearing aids while the hygienist is using a handpiece?",
      options: [
        "Remove the hearing aids completely during treatment",
        "Increase the hearing aid volume to compensate for handpiece noise",
        "Keep the hearing aids in but reduce the volume",
        "Replace hearing aids with written notes only"
      ],
      correctAnswer: 2
    },
    {
      id: 90032,
      question: "Why is documentation described as critical in the evaluation phase of the dental hygiene process of care for older adults?",
      options: [
        "Because insurance requires it only for clients over 80",
        "Because documentation replaces the need for physician consultation",
        "Because it is only needed if the client is edentulous",
        "Because health status can change quickly and all care components depend on ongoing assessment"
      ],
      correctAnswer: 3
    },
    {
      id: 90033,
      question: "Which factor is listed as complicating the treatment of older adults in a traditional dental office setting?",
      options: [
        "Excessive availability of appointment times",
        "Accessibility of the dental office",
        "Overabundance of on-site staff",
        "Lack of any legal considerations"
      ],
      correctAnswer: 1
    },
    {
      id: 90034,
      question: "Which of the following is listed as an advantage of on-site dental programs for older adults?",
      options: [
        "Increases disruption from being transported",
        "Reduces anxiety by providing a familiar environment for clients",
        "Requires more travel time for clients",
        "Eliminates the need for any oral hygiene instruction"
      ],
      correctAnswer: 1
    },
    {
      id: 90035,
      question: "According to the nutritional risk data presented, which group of Canadian seniors is more likely to be at nutritional risk?",
      options: [
        "Men, and people without depression",
        "People living with large families",
        "People with high social participation",
        "Women, and people with depression"
      ],
      correctAnswer: 3
    },
    {
      id: 90036,
      question: "True or False: The health assessment of older persons should include a functional assessment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90037,
      question: "True or False: A gerontologist is defined as an individual who investigates numerous factors that affect the aging person and the aging process.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90038,
      question: "True or False: Dental hygienists should use large-print health and personal history forms or interview the client for relevant information when treating older adults.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90039,
      question: "True or False: Dental hygienists working with institutionalized and homebound elderly clients may provide in-service educational programs, such as marking dentures for identification and developing individual care plans.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "1, Introduction to Gerontology (Part 2)": [
    {
      id: 90040,
      question: "According to the fact sheet, what has allowed many seniors to keep their natural teeth longer?",
      options: [
        "Wearing full dentures earlier in life",
        "Proper oral hygiene",
        "Avoiding dental check-ups",
        "Using only over-the-counter mouth rinses"
      ],
      correctAnswer: 1
    },
    {
      id: 90041,
      question: "Even for those wearing full or partial dentures, what does the fact sheet say is still important?",
      options: [
        "Avoiding all dental visits",
        "Removing dentures permanently",
        "Switching to a liquid-only diet",
        "Having a clean mouth and regular check-ups"
      ],
      correctAnswer: 3
    },
    {
      id: 90042,
      question: "According to the fact sheet, periodontal disease has been linked to which group of serious health conditions?",
      options: [
        "Migraines, allergies, and skin rashes",
        "Heart disease, stroke, and respiratory disorders",
        "Vision loss, hearing loss, and hair loss",
        "Muscle cramps, insomnia, and anxiety"
      ],
      correctAnswer: 1
    },
    {
      id: 90043,
      question: "How does gum disease relate to diabetes according to the fact sheet?",
      options: [
        "Gum disease has no known relationship to diabetes",
        "Gum disease always cures diabetes symptoms",
        "Gum disease may worsen diabetes or increase its complications",
        "Gum disease only affects children with diabetes"
      ],
      correctAnswer: 2
    },
    {
      id: 90044,
      question: "Where do cavities in older adults appear most frequently, according to the fact sheet?",
      options: [
        "On the biting surfaces of the front teeth",
        "Only underneath existing crowns",
        "Exclusively on the tongue side of molars",
        "On the roots of the teeth at the gum line"
      ],
      correctAnswer: 3
    },
    {
      id: 90045,
      question: "What causes tooth or root decay according to the fact sheet?",
      options: [
        "Bacteria (plaque) that should be removed daily",
        "Cold weather exposure to the teeth",
        "Excessive use of fluoridated toothpaste",
        "Natural tooth whitening over time"
      ],
      correctAnswer: 0
    },
    {
      id: 90046,
      question: "What can years of brushing too hard, combined with natural aging, cause according to the fact sheet?",
      options: [
        "Teeth to become permanently whiter",
        "Enamel to thicken and strengthen",
        "Saliva production to increase significantly",
        "Gums to recede, exposing the roots of the teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 90047,
      question: "Which of the following is listed as a sign of periodontal disease in the fact sheet?",
      options: [
        "Swollen bleeding gums and loose or shifted teeth",
        "Perfectly white and stain-free teeth",
        "Increased tooth sensitivity to cold only",
        "A stronger sense of taste"
      ],
      correctAnswer: 0
    },
    {
      id: 90048,
      question: "What is dry mouth, as defined in the fact sheet?",
      options: [
        "An increase in saliva flow",
        "A decrease in saliva flow",
        "A buildup of plaque on the tongue",
        "A loss of taste sensation only"
      ],
      correctAnswer: 1
    },
    {
      id: 90049,
      question: "Which of the following is listed as a cause of dry mouth in the fact sheet?",
      options: [
        "Drinking too much water throughout the day",
        "Chewing sugarless gum regularly",
        "Medications for high blood pressure, heart problems, or depression",
        "Using fluoridated toothpaste twice daily"
      ],
      correctAnswer: 2
    },
    {
      id: 90050,
      question: "What can dry mouth lead to, according to the fact sheet?",
      options: [
        "A permanent improvement in taste",
        "A decrease in the need for dental visits",
        "Stronger tooth enamel over time",
        "An increase in decay and periodontal disease"
      ],
      correctAnswer: 3
    },
    {
      id: 90051,
      question: "Which of the following is recommended in the fact sheet to help relieve dry mouth?",
      options: [
        "Sip water throughout the day or chew sugarless gum",
        "Avoid drinking water as much as possible",
        "Use regular sugared candy for relief",
        "Stop brushing teeth until symptoms resolve"
      ],
      correctAnswer: 0
    },
    {
      id: 90052,
      question: "According to the treatment section, what should individuals discuss with a dental hygienist?",
      options: [
        "Only their preferred toothpaste flavor",
        "Only their insurance provider details",
        "Changes in health and any oral care concerns",
        "Only the color of their dentures"
      ],
      correctAnswer: 2
    },
    {
      id: 90053,
      question: "At what angle should the toothbrush be held to the teeth according to the fact sheet?",
      options: [
        "A 45 degree angle",
        "A 90 degree angle",
        "A 15 degree angle",
        "A 180 degree angle"
      ],
      correctAnswer: 0
    },
    {
      id: 90054,
      question: "How often does the fact sheet recommend flossing?",
      options: [
        "Once a week",
        "Only after every meal",
        "Once a day",
        "Twice a month"
      ],
      correctAnswer: 2
    },
    {
      id: 90055,
      question: "Which products does the fact sheet mention as options for cleaning larger spaces between teeth or massaging gums?",
      options: [
        "Metal toothpicks and steel wool pads",
        "Rubber tip stimulators, wooden dental picks, or small proxy brushes",
        "Cotton swabs and paper towels",
        "Ice cubes and lemon wedges"
      ],
      correctAnswer: 1
    },
    {
      id: 90056,
      question: "What does the fact sheet recommend regarding dental hygiene visits for seniors?",
      options: [
        "Decrease dental hygiene visits after retirement",
        "Stop dental hygiene visits once dentures are fitted",
        "Schedule dental hygiene visits only once every five years",
        "Increase dental hygiene visits and professional teeth cleaning"
      ],
      correctAnswer: 3
    },
    {
      id: 90057,
      question: "According to the fact sheet, dentures should be brushed using what?",
      options: [
        "Bleach and cold water",
        "Abrasive scouring powder",
        "Rubbing alcohol and a wire brush",
        "Warm water and mild soap or denture paste"
      ],
      correctAnswer: 3
    },
    {
      id: 90058,
      question: "Why does the fact sheet advise against using bleach to clean or soak dentures?",
      options: [
        "Because it makes dentures too shiny",
        "Because it can discolour and weaken them",
        "Because it is too expensive to use regularly",
        "Because it removes the denture's flavor coating"
      ],
      correctAnswer: 1
    },
    {
      id: 90059,
      question: "What should be done with dentures when they are not being worn, such as at night?",
      options: [
        "Leave them exposed to open air on a shelf",
        "Store them wrapped in a dry paper towel",
        "Soak them in water or a denture cleaning solution to prevent drying",
        "Place them directly in a freezer"
      ],
      correctAnswer: 2
    },
    {
      id: 90060,
      question: "According to the fact sheet, what is the average life span of dentures?",
      options: [
        "One to two years",
        "Five to seven years",
        "Fifteen to twenty years",
        "Twenty-five to thirty years"
      ],
      correctAnswer: 1
    },
    {
      id: 90061,
      question: "What material are dental implant posts made of, according to the fact sheet?",
      options: [
        "Titanium",
        "Stainless steel",
        "Aluminum",
        "Porcelain"
      ],
      correctAnswer: 0
    },
    {
      id: 90062,
      question: "Because a dental implant is not as strong as a natural tooth, what does the fact sheet recommend?",
      options: [
        "Brushing and flossing gently",
        "Brushing with a hard-bristled brush only",
        "Avoiding brushing the implant entirely",
        "Using bleach-based cleaners on the implant"
      ],
      correctAnswer: 0
    },
    {
      id: 90063,
      question: "Which signs should individuals watch for between professional oral cancer screenings, according to the fact sheet?",
      options: [
        "Red or white patches, sores that do not heal, or swelling",
        "Slightly whiter teeth after brushing",
        "A stronger sense of smell",
        "Improved gum firmness"
      ],
      correctAnswer: 0
    },
    {
      id: 90064,
      question: "In Ontario, dental hygienists are registered with which organization, according to the fact sheet?",
      options: [
        "The Canadian Dental Association only",
        "The Ontario Ministry of Finance",
        "The College of Dental Hygienists of Ontario",
        "The provincial pharmacy licensing board"
      ],
      correctAnswer: 2
    },
    {
      id: 90065,
      question: "True or False: The fact sheet states that dentures do not have to be a fact of life, since with proper oral hygiene many seniors keep their natural teeth longer.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90066,
      question: "True or False: According to the fact sheet, commercial denture cleaning solutions replace the need to brush dentures.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90067,
      question: "True or False: The fact sheet states that denture cleansers may be toxic if ingested and should not be gargled or swallowed.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "1, Introduction to Gerontology (Part 3)": [
    {
      id: 90068,
      question: "According to the material, what has been happening to the overall rate of people without teeth (edentulism)?",
      options: [
        "It has been increasing steadily",
        "It has been decreasing over time",
        "It has remained exactly the same",
        "It has fluctuated randomly each year"
      ],
      correctAnswer: 1
    },
    {
      id: 90069,
      question: "When should dentures typically be removed for a period of time each day?",
      options: [
        "Only during dental appointments",
        "Only while eating meals",
        "Usually at night while sleeping",
        "Only during physical exercise"
      ],
      correctAnswer: 2
    },
    {
      id: 90070,
      question: "What should dentures be cleaned with every day?",
      options: [
        "A regular toothbrush with whitening toothpaste",
        "Hot water and a stiff wire brush",
        "Alcohol-based mouthwash and a cloth",
        "A denture brush and non-abrasive denture cleanser or mild dishwashing soap"
      ],
      correctAnswer: 3
    },
    {
      id: 90071,
      question: "Why is it recommended to clean dentures over a folded towel or a sink filled with water?",
      options: [
        "To protect the dentures from breaking if they are accidentally dropped",
        "To keep the bathroom counter from getting wet",
        "To make the cleaning solution work faster",
        "To prevent water spots on the denture surface"
      ],
      correctAnswer: 0
    },
    {
      id: 90072,
      question: "Where should dentures be kept when they are not in the mouth?",
      options: [
        "Soaking in a container of water",
        "Wrapped in a dry paper towel",
        "Stored in a sealed plastic bag",
        "Left uncovered on a countertop"
      ],
      correctAnswer: 0
    },
    {
      id: 90073,
      question: "If a person still has natural teeth along with dentures, how should those natural teeth be cared for?",
      options: [
        "Brushed and flossed every day with the dentures removed from the mouth",
        "Brushed only once a week to avoid irritation",
        "Cleaned only by a dentist during checkups",
        "Brushed while the dentures remain in the mouth"
      ],
      correctAnswer: 0
    },
    {
      id: 90074,
      question: "What is true about the use of denture adhesives?",
      options: [
        "They should be used to glue in dentures that do not fit properly",
        "They should completely fill the space inside the denture",
        "They are recommended only for permanent dentures, not removable ones",
        "They can be used on well-fitting dentures but not to compensate for a poor fit"
      ],
      correctAnswer: 3
    },
    {
      id: 90075,
      question: "According to manufacturer guidance mentioned in the material, how much denture adhesive should generally be used?",
      options: [
        "As much cream as needed to fill the denture completely",
        "A thick layer applied twice per day for best results",
        "The smallest amount possible, such as a few pea-sized dabs or a thin layer of powder",
        "Only enough to last for several days without reapplying"
      ],
      correctAnswer: 2
    },
    {
      id: 90076,
      question: "Why is routine professional dental care important for denture wearers, including those with no natural teeth?",
      options: [
        "It has no real benefit once all natural teeth are gone",
        "It helps detect changes in denture fit and catch problems early for simpler treatment",
        "It is only needed if the dentures are visibly broken",
        "It is required solely for cosmetic whitening purposes"
      ],
      correctAnswer: 1
    },
    {
      id: 90077,
      question: "Individuals with no teeth should still see a dentist annually for an oral evaluation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "1, Introduction to Gerontology (Part 4)": [
    {
      id: 90078,
      question: "Which of the following is listed as a prevention measure for oral candidiasis in Box 61-9?",
      options: [
        "Keeping dentures in the mouth overnight",
        "Avoiding all oral hygiene products",
        "Removing dentures overnight",
        "Applying antifungal cream to healthy skin"
      ],
      correctAnswer: 2
    },
    {
      id: 90079,
      question: "What saline rinse concentration is recommended for prevention of oral candidiasis?",
      options: [
        "2 tablespoons of salt in 1 cup of water",
        "1 teaspoon of salt in 1 pint of water",
        "1/2 teaspoon of salt in 1 quart of water",
        "1/4 teaspoon of salt in 1 gallon of water"
      ],
      correctAnswer: 2
    },
    {
      id: 90080,
      question: "What is the recommended dosage and frequency for Nystatin oral suspension in first-route treatment?",
      options: [
        "200,000-500,000 IU, swished and swallowed 3-5 times a day",
        "10 mg, swished and swallowed once a day",
        "50-100 mg, swished only, for 7-14 days",
        "100-200 mg, swallowed twice weekly"
      ],
      correctAnswer: 0
    },
    {
      id: 90081,
      question: "How is frozen Nystatin suspension recommended to be administered?",
      options: [
        "Mixed into hot tea before swallowing",
        "Frozen in sugarless fruit juice",
        "Dissolved in carbonated soda",
        "Applied directly to the gums with a swab"
      ],
      correctAnswer: 1
    },
    {
      id: 90082,
      question: "What is the recommended dosage and duration for Clotrimazole troche in first-route treatment?",
      options: [
        "100 mg, once a day for 7 days",
        "10 mg, 5 times a day for 14 days",
        "5 mg, twice a day for 30 days",
        "50 mg, 3 times a day for 10 days"
      ],
      correctAnswer: 1
    },
    {
      id: 90083,
      question: "According to the first-route treatment guidance, how long should a patient avoid eating or drinking after topical antifungal treatment?",
      options: [
        "20 minutes",
        "2 hours",
        "5 minutes",
        "Until the next morning"
      ],
      correctAnswer: 0
    },
    {
      id: 90084,
      question: "Along with topical medication, what denture-related steps are part of first-route treatment?",
      options: [
        "Replacing the denture entirely every week",
        "Soaking the denture only once a month",
        "Discontinuing all denture care during treatment",
        "Using a new denture container and toothbrush, and treating the denture daily"
      ],
      correctAnswer: 3
    },
    {
      id: 90085,
      question: "Which systemic medication listed for second-route treatment may be given intravenously?",
      options: [
        "Fluconazole",
        "Amphotericin B",
        "Clotrimazole",
        "Nystatin"
      ],
      correctAnswer: 1
    },
    {
      id: 90086,
      question: "If oral candidiasis is not responding to treatment, what further lab tests may be needed?",
      options: [
        "Complete blood count only",
        "Chest X-ray and ECG",
        "Allergy skin testing",
        "Cytologic smear, culture, or biopsy"
      ],
      correctAnswer: 3
    },
    {
      id: 90087,
      question: "Continuing denture treatment and introducing new oral care products is recommended as part of second-route systemic treatment for oral candidiasis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "2. The Oral Cavity and Aging (Part 1)": [
    {
      id: 90088,
      question: "What is the clinical term for total tooth loss?",
      options: [
        "Xerostomia",
        "Edentulousness",
        "Cheilitis",
        "Hyperplasia"
      ],
      correctAnswer: 1
    },
    {
      id: 90089,
      question: "Approximately what proportion of adults aged 65 or older in the United States and Canada are edentulous?",
      options: [
        "One in ten",
        "One in five",
        "One in three",
        "One in two"
      ],
      correctAnswer: 1
    },
    {
      id: 90090,
      question: "Which of the following is NOT listed as a risk factor for tooth loss?",
      options: [
        "High socioeconomic status",
        "Poor daily oral hygiene",
        "Dental caries",
        "Periodontal diseases"
      ],
      correctAnswer: 0
    },
    {
      id: 90091,
      question: "Which psychologic factor is associated with tooth loss?",
      options: [
        "Greater social confidence",
        "Increased sexuality",
        "Improved self-esteem",
        "Fear of aging"
      ],
      correctAnswer: 3
    },
    {
      id: 90092,
      question: "Which of the following is a physiologic factor linked to becoming edentulous?",
      options: [
        "Enhanced taste perception",
        "Improved bone density",
        "Increased salivary flow",
        "Loss of orofacial muscle tone"
      ],
      correctAnswer: 3
    },
    {
      id: 90093,
      question: "Which condition contributes to residual ridge and alveolar bone resorption?",
      options: [
        "High-protein diet",
        "Fluoride varnish use",
        "Postmenopausal osteoporosis",
        "Frequent dental visits"
      ],
      correctAnswer: 2
    },
    {
      id: 90094,
      question: "What causes alveolar bone loss after tooth extraction according to the presented model?",
      options: [
        "Continuous chewing force",
        "Increased calcium intake",
        "Excess downward pressure on the alveolar bone",
        "Lack of downward pressure on the alveolar bone"
      ],
      correctAnswer: 3
    },
    {
      id: 90095,
      question: "Why are mandibular tori often removed before fabricating a removable partial denture (RPD)?",
      options: [
        "They increase salivary flow near the site",
        "They improve retention of the prosthesis",
        "The thin mucosa over them ulcerates easily under a connector",
        "They reduce plaque accumulation nearby"
      ],
      correctAnswer: 2
    },
    {
      id: 90096,
      question: "What instruments are used to remove bony tori?",
      options: [
        "Cotton pliers and floss",
        "Scalers and curettes",
        "Burrs and chisels",
        "Rubber cups and pumice"
      ],
      correctAnswer: 2
    },
    {
      id: 90097,
      question: "In fixed partial dental prostheses, what is the term for the tooth used to anchor the prosthesis and support the pontic?",
      options: [
        "Pontic",
        "Obturator",
        "Abutment",
        "Connector"
      ],
      correctAnswer: 2
    },
    {
      id: 90098,
      question: "In fixed partial dental prostheses, what is the term for the artificial tooth that occupies the edentulous space?",
      options: [
        "Abutment",
        "Retainer clasp",
        "Major connector",
        "Pontic"
      ],
      correctAnswer: 3
    },
    {
      id: 90099,
      question: "Which type of prosthesis replaces an entire arch of missing teeth with no remaining natural teeth?",
      options: [
        "Removable partial denture",
        "Complete denture",
        "Fixed partial denture",
        "Obturator"
      ],
      correctAnswer: 1
    },
    {
      id: 90100,
      question: "Which prosthesis uses retainer clasps and a major connector to attach to remaining natural teeth?",
      options: [
        "Fixed partial denture",
        "Removable partial denture",
        "Complete denture",
        "Obturator"
      ],
      correctAnswer: 1
    },
    {
      id: 90101,
      question: "A prosthesis used to close an oral defect, such as one resulting from surgery, is called what?",
      options: [
        "A complete denture",
        "An abutment",
        "A pontic",
        "An obturator"
      ],
      correctAnswer: 3
    },
    {
      id: 90102,
      question: "In the removable partial denture clasp image, what problem was noted at the gingival third of the abutment tooth?",
      options: [
        "Retained plaque biofilm under the clasp",
        "Gingival recession only",
        "Enamel hypoplasia",
        "Root fracture"
      ],
      correctAnswer: 0
    },
    {
      id: 90103,
      question: "Which of the following is NOT listed as a challenge associated with replacing missing teeth?",
      options: [
        "Speech disturbances",
        "Reduced masticatory efficiency",
        "Improved masticatory efficiency without adjustment",
        "Physical appearance changes"
      ],
      correctAnswer: 2
    },
    {
      id: 90104,
      question: "What happens to facial proportions when missing teeth are not replaced, according to the facial contour comparison?",
      options: [
        "Facial height increases dramatically",
        "Bite collapse occurs and lip/cheek support is lost",
        "Lip support improves",
        "Wrinkles are reduced"
      ],
      correctAnswer: 1
    },
    {
      id: 90105,
      question: "Which of the following is a factor affecting the oral mucosa of denture-wearing individuals?",
      options: [
        "Increased salivary flow",
        "Improved bone density",
        "Reduced denture wear time",
        "Xerostomia"
      ],
      correctAnswer: 3
    },
    {
      id: 90106,
      question: "Which autoimmune condition is specifically listed as a cause of xerostomia?",
      options: [
        "Sjogren's syndrome",
        "Hashimoto's thyroiditis",
        "Type 1 diabetes",
        "Rheumatoid arthritis"
      ],
      correctAnswer: 0
    },
    {
      id: 90107,
      question: "Which of the following is listed as a factor associated with xerostomia?",
      options: [
        "Improved hormonal balance",
        "Increased fluid balance",
        "Polyuric states",
        "Reduced medication use"
      ],
      correctAnswer: 2
    },
    {
      id: 90108,
      question: "What is the recommended oral pilocarpine dose for radiation-induced xerostomia?",
      options: [
        "5 to 10 mg three times daily",
        "1 to 2 mg once daily",
        "20 mg twice daily",
        "50 mg once weekly"
      ],
      correctAnswer: 0
    },
    {
      id: 90109,
      question: "What is the recommended oral pilocarpine dose for xerostomia associated with Sjogren's syndrome?",
      options: [
        "2 mg six times daily",
        "10 mg once daily",
        "15 mg twice daily",
        "5 mg four times daily"
      ],
      correctAnswer: 3
    },
    {
      id: 90110,
      question: "How long do the effects of oral pilocarpine typically last?",
      options: [
        "Twelve hours",
        "Three to five hours",
        "Thirty minutes",
        "One full day"
      ],
      correctAnswer: 1
    },
    {
      id: 90111,
      question: "Which of the following is part of dental hygiene care for clients with removable prostheses?",
      options: [
        "Recommending continuous nonstop wear",
        "Ignoring mucosa irritations",
        "Assessing occlusion and fit",
        "Avoiding oral hygiene instruction"
      ],
      correctAnswer: 2
    },
    {
      id: 90112,
      question: "Mucosal conditions related to dentures are generally categorized into which groups?",
      options: [
        "Reactive/traumatic, infectious, and mixed",
        "Vascular, endocrine, and metabolic",
        "Allergic, neoplastic, and idiopathic",
        "Viral, genetic, and congenital"
      ],
      correctAnswer: 0
    },
    {
      id: 90113,
      question: "A reactive lesion characterized by folds of excess tissue caused by an ill-fitting denture flange is called what?",
      options: [
        "Chronic candidiasis",
        "Fibrous hyperplasia only",
        "Angular cheilitis",
        "Epulis fissuratum"
      ],
      correctAnswer: 3
    },
    {
      id: 90114,
      question: "Which infectious lesion commonly appears as redness and cracking at the corners of the mouth in denture wearers?",
      options: [
        "Traumatic ulcer",
        "Epulis fissuratum",
        "Fibrous hyperplasia",
        "Angular cheilitis"
      ],
      correctAnswer: 3
    },
    {
      id: 90115,
      question: "Which infectious lesion often presents as redness under the palatal area covered by a denture?",
      options: [
        "Traumatic ulcer",
        "Epulis fissuratum",
        "Chronic candidiasis",
        "Fibrous hyperplasia"
      ],
      correctAnswer: 2
    },
    {
      id: 90116,
      question: "Denture-induced papillary hyperplasia is classified under which mucosal lesion category?",
      options: [
        "Mixed reactive and infectious",
        "Purely traumatic",
        "Purely genetic",
        "Purely infectious"
      ],
      correctAnswer: 0
    },
    {
      id: 90117,
      question: "Why is regular professional assessment of oral tissues important for denture wearers?",
      options: [
        "Professional visits are only needed for cleaning",
        "Denture wearers cannot develop oral lesions",
        "Denture irritation may be a co-carcinogenic factor in predisposed individuals",
        "Dentures never require reassessment once fitted"
      ],
      correctAnswer: 2
    },
    {
      id: 90118,
      question: "What commonly happens to nutritional status when a prosthesis is ill-fitting?",
      options: [
        "Nutritional status may suffer because eating becomes less pleasurable",
        "Nutritional status always improves",
        "Fiber intake automatically increases",
        "Protein intake automatically increases"
      ],
      correctAnswer: 0
    },
    {
      id: 90119,
      question: "Which dietary tendency is common among aged edentulous individuals?",
      options: [
        "Preference for raw, fibrous vegetables",
        "Preference for a soft diet high in carbohydrate and refined sugar",
        "Preference for tough, chewy meats",
        "Preference for high-fiber, protein-rich foods"
      ],
      correctAnswer: 1
    },
    {
      id: 90120,
      question: "How can xerostomia combined with denture wear affect food choices?",
      options: [
        "Clients chew more vigorously without issue",
        "Clients may avoid foods requiring a lot of chewing due to friction and dry mouth",
        "Saliva production increases to compensate",
        "Food choices remain completely unaffected"
      ],
      correctAnswer: 1
    },
    {
      id: 90121,
      question: "Which type of denture cleanser dissolves mucins and organic substances but can corrode metal?",
      options: [
        "Ultrasonic cleaning devices",
        "Alkaline hypochlorite",
        "Microwave radiation",
        "Chlorhexidine gluconate solution"
      ],
      correctAnswer: 1
    },
    {
      id: 90122,
      question: "Which antimicrobial denture cleansing method uses electromagnetic waves and is intended for in-office use only?",
      options: [
        "Microwave radiation",
        "Alkaline peroxide",
        "Chlorhexidine gluconate solution",
        "Alkaline hypochlorite"
      ],
      correctAnswer: 0
    },
    {
      id: 90123,
      question: "Which denture cleanser is antibacterial and antifungal but may stain denture teeth and only temporarily relieves denture stomatitis symptoms?",
      options: [
        "Chlorhexidine gluconate solution",
        "Microwave radiation",
        "Ultrasonic cleaning devices",
        "Alkaline hypochlorite"
      ],
      correctAnswer: 0
    },
    {
      id: 90124,
      question: "The decline in edentulousness has been one of the most significant changes in older adults' oral status over the last century.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90125,
      question: "According to the presented model, alveolar bone resorption occurs because of increased downward pressure after tooth loss.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90126,
      question: "Oral pilocarpine for Sjogren's-related xerostomia is typically dosed once daily at 50 mg.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90127,
      question: "Aged edentulous individuals commonly show a dietary tendency toward more protein-rich and high-fiber foods.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "2. The Oral Cavity and Aging (Part 2)": [
    {
      id: 90128,
      question: "What percentage of adults aged 65 years or older have gum disease?",
      options: [
        "68%",
        "46%",
        "25%",
        "14%"
      ],
      correctAnswer: 0
    },
    {
      id: 90129,
      question: "What proportion of older adults have untreated tooth decay?",
      options: [
        "1 in 10",
        "1 in 5",
        "1 in 3",
        "1 in 2"
      ],
      correctAnswer: 1
    },
    {
      id: 90130,
      question: "Approximately what proportion of adults aged 65 or older have lost all of their natural teeth?",
      options: [
        "1 in 10",
        "1 in 3",
        "1 in 5",
        "1 in 4"
      ],
      correctAnswer: 2
    },
    {
      id: 90131,
      question: "What percentage of elders actually visit the dentist?",
      options: [
        "70%",
        "25%",
        "90%",
        "46%"
      ],
      correctAnswer: 3
    },
    {
      id: 90132,
      question: "What percentage of elders lack dental insurance?",
      options: [
        "70%",
        "46%",
        "25%",
        "90%"
      ],
      correctAnswer: 0
    },
    {
      id: 90133,
      question: "Approximately how many elders reside in nursing facilities?",
      options: [
        "500,000",
        "1.5 million",
        "3 million",
        "6.6 million"
      ],
      correctAnswer: 1
    },
    {
      id: 90134,
      question: "What percentage of nursing facility residents cannot brush their own teeth or care for their dentures?",
      options: [
        "16%",
        "46%",
        "70-90%",
        "25%"
      ],
      correctAnswer: 2
    },
    {
      id: 90135,
      question: "In nursing facilities, what percentage of residents receive any oral care, with an average brushing time of only 16 seconds?",
      options: [
        "46%",
        "68%",
        "25%",
        "16%"
      ],
      correctAnswer: 3
    },
    {
      id: 90136,
      question: "Approximately how many elders are considered \"near poor\" or poor?",
      options: [
        "6.6 million",
        "1.5 million",
        "9,500",
        "49,000"
      ],
      correctAnswer: 0
    },
    {
      id: 90137,
      question: "What percentage of adults over 65 live in rural communities?",
      options: [
        "25%",
        "14%",
        "46%",
        "70%"
      ],
      correctAnswer: 1
    },
    {
      id: 90138,
      question: "Which condition commonly results from tooth loss and poorly fitting dentures causing creasing of the skin at the corners of the mouth?",
      options: [
        "Leukoplakia",
        "Denture stomatitis",
        "Angular cheilitis",
        "Erythroplakia"
      ],
      correctAnswer: 2
    },
    {
      id: 90139,
      question: "Which of the following is the most common risk factor for denture stomatitis?",
      options: [
        "Xerostomia",
        "Nutritional deficiency",
        "Diabetes",
        "Continuous denture wear"
      ],
      correctAnswer: 3
    },
    {
      id: 90140,
      question: "How should dentures be brushed to avoid damaging the denture material?",
      options: [
        "Liquid hand soap, dishwashing liquid, or denture cleaning paste",
        "Regular toothpaste and a hard-bristle brush",
        "Bleach-based cleaning solution",
        "Alcohol-based mouthwash"
      ],
      correctAnswer: 0
    },
    {
      id: 90141,
      question: "For how many hours should dentures be removed from the mouth each night?",
      options: [
        "About 2 hours",
        "At least 8 hours",
        "About 4 hours",
        "About 12 hours"
      ],
      correctAnswer: 1
    },
    {
      id: 90142,
      question: "Which organism is most often implicated in the etiology of denture stomatitis?",
      options: [
        "Streptococcus",
        "Staphylococcus",
        "Candida",
        "E. coli"
      ],
      correctAnswer: 2
    },
    {
      id: 90143,
      question: "Which type of dental caries is especially common in the elderly due to gingival recession exposing the tooth root?",
      options: [
        "Pit and fissure caries",
        "Interproximal caries",
        "Rampant caries",
        "Root caries"
      ],
      correctAnswer: 3
    },
    {
      id: 90144,
      question: "Which of the following is NOT listed as a risk factor for caries in elderly patients?",
      options: [
        "High level of physical activity",
        "Xerostomia",
        "Low socioeconomic status",
        "Inadequate fluoride exposure"
      ],
      correctAnswer: 0
    },
    {
      id: 90145,
      question: "Which off-label topical treatment arrests carious lesions within 2 years in 91% of patients and is useful for patients with cognitive or physical limitations?",
      options: [
        "Fluoride varnish alone",
        "Silver diamine fluoride",
        "Root canal therapy",
        "Chlorhexidine rinse"
      ],
      correctAnswer: 1
    },
    {
      id: 90146,
      question: "What differentiates gingivitis from periodontitis?",
      options: [
        "Gingivitis involves loss of supporting bone",
        "Periodontitis shows no bleeding",
        "Gingivitis has no destruction of the periodontal ligament or bone",
        "Periodontitis is fully reversible"
      ],
      correctAnswer: 2
    },
    {
      id: 90147,
      question: "What is a caution associated with using chlorhexidine to treat periodontitis?",
      options: [
        "It whitens the teeth over time",
        "It cures active caries lesions",
        "It increases salivary flow",
        "It may stain teeth yellow to brown"
      ],
      correctAnswer: 3
    },
    {
      id: 90148,
      question: "Leukoplakia (\"white patch\") and erythroplakia (\"red patch\") are best described as:",
      options: [
        "Premalignant conditions",
        "Benign and completely harmless",
        "Signs of vitamin deficiency",
        "Normal age-related changes"
      ],
      correctAnswer: 0
    },
    {
      id: 90149,
      question: "How long should an unexplained white lesion persist before it should be biopsied?",
      options: [
        "1 week",
        "2 weeks",
        "1 month",
        "6 weeks"
      ],
      correctAnswer: 1
    },
    {
      id: 90150,
      question: "Oral cancer accounts for approximately what percentage of all cancers in the US?",
      options: [
        "10%",
        "25%",
        "4%",
        "50%"
      ],
      correctAnswer: 2
    },
    {
      id: 90151,
      question: "Which virus is associated with an increased risk of oral cancer?",
      options: [
        "HIV",
        "Hepatitis B",
        "Epstein-Barr virus",
        "Human Papilloma Virus (HPV 16)"
      ],
      correctAnswer: 3
    },
    {
      id: 90152,
      question: "What is the approximate 5-year survival rate for oral cancer?",
      options: [
        "50%",
        "25%",
        "75%",
        "90%"
      ],
      correctAnswer: 0
    },
    {
      id: 90153,
      question: "Which class of medications is most commonly associated with causing xerostomia?",
      options: [
        "Antibiotics and antivirals",
        "Antihypertensives, antidepressants, antihistamines, diuretics",
        "Vitamins and supplements",
        "Topical antifungal agents"
      ],
      correctAnswer: 1
    },
    {
      id: 90154,
      question: "What is the most important natural protective factor against dental caries that is reduced in xerostomia?",
      options: [
        "Fluoride toothpaste",
        "Enamel thickness",
        "Saliva",
        "Vitamin C intake"
      ],
      correctAnswer: 2
    },
    {
      id: 90155,
      question: "Which concentration of topical fluoride is recommended for patients at high caries risk, such as those with xerostomia?",
      options: [
        "0.05% sodium fluoride",
        "0.5% sodium fluoride",
        "2.2% sodium fluoride",
        "1.1% sodium fluoride"
      ],
      correctAnswer: 3
    },
    {
      id: 90156,
      question: "Which medications are commonly associated with gingival overgrowth?",
      options: [
        "Phenytoin, methotrexate, calcium channel blockers",
        "Antibiotics such as amoxicillin",
        "NSAIDs like ibuprofen",
        "Statins for cholesterol"
      ],
      correctAnswer: 0
    },
    {
      id: 90157,
      question: "IV bisphosphonates are associated with which serious oral complication?",
      options: [
        "Dental caries",
        "Osteonecrosis of the jaw",
        "Gingival overgrowth",
        "Dry mouth (xerostomia)"
      ],
      correctAnswer: 1
    },
    {
      id: 90158,
      question: "What is the estimated prevalence of bisphosphonate-related osteonecrosis of the jaw?",
      options: [
        "5%",
        "25%",
        "0.1%",
        "50%"
      ],
      correctAnswer: 2
    },
    {
      id: 90159,
      question: "The relationship between diabetes and periodontal disease is best described as:",
      options: [
        "No known connection at all",
        "A one-way relationship only",
        "A relationship limited to children",
        "A vicious, bidirectional cycle"
      ],
      correctAnswer: 3
    },
    {
      id: 90160,
      question: "Treating periodontal disease can result in approximately what improvement in glycemic control?",
      options: [
        "10-20%",
        "1-2%",
        "50%",
        "90%"
      ],
      correctAnswer: 0
    },
    {
      id: 90161,
      question: "Oral care protocol interventions have been shown to reduce ventilator-associated pneumonia by approximately what percentage?",
      options: [
        "25%",
        "89.7%",
        "50%",
        "16%"
      ],
      correctAnswer: 1
    },
    {
      id: 90162,
      question: "Which of the following medical conditions requires antibiotic prophylaxis prior to certain dental procedures according to the 2017 AHA update?",
      options: [
        "Prosthetic joint implants",
        "Well-controlled type 2 diabetes",
        "Previous infective endocarditis",
        "Well-controlled hypertension"
      ],
      correctAnswer: 2
    },
    {
      id: 90163,
      question: "What INR range is generally considered acceptable for most dental procedures without interrupting anticoagulation?",
      options: [
        "1.0-1.5",
        "4.0-5.0",
        "0.5-1.0",
        "1.8-3.5"
      ],
      correctAnswer: 3
    },
    {
      id: 90164,
      question: "A thorough oral assessment should include palpation of which structures?",
      options: [
        "Neck, temporomandibular joint, and floor of the mouth",
        "Only the visible teeth",
        "Only the tongue surface",
        "Only the lips"
      ],
      correctAnswer: 0
    },
    {
      id: 90165,
      question: "What is the average number of remaining natural teeth in adults over age 65?",
      options: [
        "10",
        "18",
        "24",
        "32"
      ],
      correctAnswer: 1
    },
    {
      id: 90166,
      question: "What percentage of adults over 65 are completely edentulous (have no natural teeth)?",
      options: [
        "10%",
        "46%",
        "25%",
        "70%"
      ],
      correctAnswer: 2
    },
    {
      id: 90167,
      question: "Which of the following is a known oral complication after a stroke, involving poor clearance of food from the mouth?",
      options: [
        "Increased salivary flow",
        "Improved tongue mobility",
        "Enhanced taste sensation",
        "Increased food packing"
      ],
      correctAnswer: 3
    },
    {
      id: 90168,
      question: "Based on U.S. population projections, how is the number of older adults expected to change from 2015 to 2060?",
      options: [
        "It is projected to more than double",
        "It is projected to decrease steadily",
        "It is projected to remain flat",
        "It is projected to fall by half"
      ],
      correctAnswer: 0
    },
    {
      id: 90169,
      question: "Which of the following is a common oral effect of stroke-related impairment?",
      options: [
        "Improved chewing dexterity",
        "Poor tongue function and lip seal",
        "Increased saliva clearance",
        "Decreased caries risk"
      ],
      correctAnswer: 1
    },
    {
      id: 90170,
      question: "In patients with rheumatoid arthritis, diminished salivary output is often linked to which condition?",
      options: [
        "Osteoporosis",
        "Diabetes mellitus",
        "Sjögren's syndrome",
        "Hypertension"
      ],
      correctAnswer: 2
    },
    {
      id: 90171,
      question: "Which of the following is a contributing factor to poor oral health in patients with dementia?",
      options: [
        "Increased manual dexterity",
        "Improved compliance with hygiene",
        "Enhanced swallowing ability",
        "Resistance to care and self-care deficits"
      ],
      correctAnswer: 3
    },
    {
      id: 90172,
      question: "Taste alteration (dysgeusia) is associated with how many different medications?",
      options: [
        "Over 200",
        "About 10",
        "About 50",
        "Over 1,000"
      ],
      correctAnswer: 0
    },
    {
      id: 90173,
      question: "Which of the following findings during an oral exam might raise concern for elder abuse?",
      options: [
        "Well-fitted dentures",
        "Bruises to the chin or earlobes at varying stages of healing",
        "Normal hydration status",
        "Good oral hygiene"
      ],
      correctAnswer: 1
    },
    {
      id: 90174,
      question: "Oral hygiene protocols in hospitals and nursing facilities can reduce pneumonia incidence and prevent approximately how many pneumonia deaths?",
      options: [
        "1 in 2",
        "1 in 50",
        "1 in 10",
        "1 in 100"
      ],
      correctAnswer: 2
    },
    {
      id: 90175,
      question: "Which finding is often seen on oral examination in a patient with xerostomia?",
      options: [
        "Wet, glistening mucosa with pooled saliva",
        "Excessive salivary pooling",
        "Normal moisture with no changes",
        "Dry and friable mucosa with no pooling of saliva"
      ],
      correctAnswer: 3
    },
    {
      id: 90176,
      question: "Prophylactic antibiotics are generally recommended for patients with prosthetic joint implants prior to dental procedures.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90177,
      question: "Dentures should be removed during an oral examination to properly assess the soft tissue and teeth underneath.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90178,
      question: "Treatment of periodontal disease has been proven to reduce cardiovascular risk.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90179,
      question: "Continuing anticoagulation therapy is generally preferred over discontinuing it for routine dental cleanings, fillings, and simple extractions.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90180,
      question: "Squamous cell carcinoma of the lip is uncommon in older adults and rarely presents as a non-healing lesion.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "3. Process of Care & the Older Adult": [
    {
      id: 90181,
      question: "According to the required readings, which chapter in Darby & Walsh's Dental Hygiene: Theory and Practice covers 'The Older Adult'?",
      options: [
        "Chapter 57",
        "Chapter 55",
        "Chapter 56",
        "Chapter 54"
      ],
      correctAnswer: 1
    },
    {
      id: 90182,
      question: "Which chapter covers 'Persons with Fixed and Removable Dental Prostheses'?",
      options: [
        "Chapter 55",
        "Chapter 56",
        "Chapter 54",
        "Chapter 58"
      ],
      correctAnswer: 1
    },
    {
      id: 90183,
      question: "Where do dental hygienists begin assessing the overall physical factors of an older adult?",
      options: [
        "In the consultation office",
        "In the radiography room",
        "In the sterilization area",
        "In the reception area"
      ],
      correctAnswer: 3
    },
    {
      id: 90184,
      question: "Which of the following is specifically noted as an assessment consideration when observing an older adult upon arrival?",
      options: [
        "Gait and balance",
        "Hand dominance",
        "Shoe size",
        "Hair color"
      ],
      correctAnswer: 0
    },
    {
      id: 90185,
      question: "Besides gait and balance, what other physical transfer situation is specifically mentioned as part of assessment?",
      options: [
        "Stretcher transfer",
        "Car seat transfer",
        "Wheelchair transfer",
        "Elevator transfer"
      ],
      correctAnswer: 2
    },
    {
      id: 90186,
      question: "Which of the following is listed as a factor to consider regarding communication with older clients?",
      options: [
        "Vision and hearing impairments",
        "Preferred appointment day",
        "Handwriting style",
        "Insurance provider"
      ],
      correctAnswer: 0
    },
    {
      id: 90187,
      question: "What should the health history form for an older adult include?",
      options: [
        "Only insurance information",
        "Only current dental complaints",
        "The client's personal, medical, and dental background",
        "Only emergency contact information"
      ],
      correctAnswer: 2
    },
    {
      id: 90188,
      question: "Both prescription and over-the-counter medications must be reviewed for what purpose?",
      options: [
        "Insurance coverage",
        "Appointment scheduling",
        "Oral implications",
        "Billing accuracy"
      ],
      correctAnswer: 2
    },
    {
      id: 90189,
      question: "Which term refers to the use of multiple medications, an important consideration in older adult health history?",
      options: [
        "Comorbidity",
        "Polypharmacy",
        "Monotherapy",
        "Xerostomia"
      ],
      correctAnswer: 1
    },
    {
      id: 90190,
      question: "Reduced muscle tone associated with aging, as noted in the assessment section, is referred to as what?",
      options: [
        "Sarcopenia",
        "Presbyopia",
        "Dysphagia",
        "Osteopenia"
      ],
      correctAnswer: 0
    },
    {
      id: 90191,
      question: "TMJ changes in older adults are associated with which two conditions mentioned in the material?",
      options: [
        "Diabetes and hypertension",
        "Anemia and arthritis",
        "Osteoporosis and osteoarthritis",
        "Asthma and bronchitis"
      ],
      correctAnswer: 2
    },
    {
      id: 90192,
      question: "In addition to muscle tone and TMJ, which two other areas are specifically listed for assessment?",
      options: [
        "Lips, and quantity/quality of saliva",
        "Nails and skin tone",
        "Ears and hearing aids",
        "Hair and scalp condition"
      ],
      correctAnswer: 0
    },
    {
      id: 90193,
      question: "According to the oral cancer self-examination information, what is the estimated survival rate when oral cancer is detected early?",
      options: [
        "95 percent",
        "65 percent",
        "50 percent",
        "80 percent"
      ],
      correctAnswer: 3
    },
    {
      id: 90194,
      question: "What supplies are recommended for the monthly oral cancer self-examination routine?",
      options: [
        "Tongue depressor and mouthwash",
        "Cotton swabs and alcohol wipes",
        "Flashlight, small mirror, piece of gauze, wall mirror",
        "Dental floss and a toothpick"
      ],
      correctAnswer: 2
    },
    {
      id: 90195,
      question: "During a self-examination, what should a person use to help examine all sides of the tongue?",
      options: [
        "A piece of gauze between finger and thumb",
        "A toothbrush",
        "A mouth mirror only",
        "A cotton ball"
      ],
      correctAnswer: 0
    },
    {
      id: 90196,
      question: "Any mouth sore that has not healed after how many days should be reported?",
      options: [
        "7 days",
        "3 days",
        "14 days",
        "30 days"
      ],
      correctAnswer: 2
    },
    {
      id: 90197,
      question: "Why should the older client's nutritional status be evaluated according to the material?",
      options: [
        "Because it determines appointment length only",
        "Because insurance requires it",
        "Because of physiologic and psychosocial complexities documented in dietary patterns for the elderly",
        "Because it is unrelated to oral health"
      ],
      correctAnswer: 2
    },
    {
      id: 90198,
      question: "On the nutritional screening tool shown, a score of 12-14 points indicates what nutritional status?",
      options: [
        "At risk of malnutrition",
        "Malnourished",
        "Severe deficiency",
        "Normal nutritional status"
      ],
      correctAnswer: 3
    },
    {
      id: 90199,
      question: "On the same nutritional screening tool, a score of 0-7 points indicates what status?",
      options: [
        "Overnourished",
        "At risk of malnutrition",
        "Normal nutritional status",
        "Malnourished"
      ],
      correctAnswer: 3
    },
    {
      id: 90200,
      question: "Care planning and implementation for older adults should be based on which of the following factors, according to the material?",
      options: [
        "Only the client's age",
        "Only the client's preferred appointment time",
        "Dental hygiene diagnosis, chronic condition severity, cognitive abilities, self-care level, expectations, and financial ability",
        "Only the client's insurance plan"
      ],
      correctAnswer: 2
    },
    {
      id: 90201,
      question: "What type of appointment scheduling is recommended for older clients along with a stress reduction protocol?",
      options: [
        "Evening appointments only",
        "Short morning appointments",
        "Long afternoon appointments",
        "Weekend-only appointments"
      ],
      correctAnswer: 1
    },
    {
      id: 90202,
      question: "Why is dental hygiene care planning for older adults often more complex than for younger persons?",
      options: [
        "Because older adults require less documentation",
        "Because insurance forms are longer",
        "Because the vast majority have at least one chronic condition and many have complex dental and periodontal conditions",
        "Because appointments are shorter"
      ],
      correctAnswer: 2
    },
    {
      id: 90203,
      question: "According to the planning section, how do many older adults tend to view oral problems?",
      options: [
        "As unrelated to overall health",
        "As an inevitable part of aging",
        "As primarily a cosmetic issue",
        "As a curable condition requiring urgent care"
      ],
      correctAnswer: 1
    },
    {
      id: 90204,
      question: "What does research suggest about how older people perceive their need for dental care?",
      options: [
        "They have no perception of need at all",
        "They perceive a lower need than what is actually required",
        "They perceive the same need as younger adults",
        "They perceive a higher need than what is actually required"
      ],
      correctAnswer: 1
    },
    {
      id: 90205,
      question: "What is identified as a barrier to dental care use for many older adults?",
      options: [
        "Distance to office only",
        "Lack of transportation only",
        "Cost of care",
        "Lack of available appointments"
      ],
      correctAnswer: 2
    },
    {
      id: 90206,
      question: "Why is minimal trauma to the gingiva especially important during instrumentation of older clients?",
      options: [
        "Because of increased pain tolerance",
        "Because their teeth are more sensitive",
        "Because their gingiva is thicker",
        "Because of reduction in healing capabilities"
      ],
      correctAnswer: 3
    },
    {
      id: 90207,
      question: "What two conditions are noted as making retraction of oral tissues uncomfortable in older clients?",
      options: [
        "Loss of elasticity of lips/oral mucosa and xerostomia",
        "Gingival hyperplasia and halitosis",
        "Excess saliva and swelling",
        "Bruxism and malocclusion"
      ],
      correctAnswer: 0
    },
    {
      id: 90208,
      question: "Older adults with a history of periodontal disease need what type of follow-up care?",
      options: [
        "Annual periodontal maintenance only",
        "More-frequent periodontal maintenance therapy",
        "No further periodontal maintenance",
        "Less frequent periodontal maintenance"
      ],
      correctAnswer: 1
    },
    {
      id: 90209,
      question: "Why might scaling be completed by quadrants for older adults?",
      options: [
        "To reduce the cost of treatment",
        "To allow for short appointment times",
        "To simplify billing codes",
        "To avoid using anesthesia"
      ],
      correctAnswer: 1
    },
    {
      id: 90210,
      question: "For clients requiring antibiotic premedication, what is the recommended approach to appointment scheduling, given possible limitations?",
      options: [
        "Schedule only emergency visits",
        "Avoid providing any care until premedication is discontinued",
        "Spread care over many very short visits regardless of medical condition",
        "Complete as much care as possible at one time, though the person's medical condition may make lengthy appointments difficult"
      ],
      correctAnswer: 3
    },
    {
      id: 90211,
      question: "Which of the following is listed as a chemotherapeutic/product option mentioned under implementation?",
      options: [
        "Insulin",
        "Penicillin",
        "Aspirin",
        "Triclosan"
      ],
      correctAnswer: 3
    },
    {
      id: 90212,
      question: "Which product mentioned under implementation contains Novamin?",
      options: [
        "Fluoride varnish",
        "Xylitol gum",
        "Essential oil rinse",
        "MI Paste"
      ],
      correctAnswer: 3
    },
    {
      id: 90213,
      question: "After completing an appointment, how should the dental chair be returned to an upright position?",
      options: [
        "Quickly, to save time",
        "Only after the client stands up",
        "In two abrupt stages",
        "Slowly"
      ],
      correctAnswer: 3
    },
    {
      id: 90214,
      question: "Why should an older client be allowed to sit up for a short time before dismissal from the chair?",
      options: [
        "To avoid problems with postural hypotension",
        "To review insurance paperwork",
        "To allow time for a snack",
        "To wait for a caregiver to arrive"
      ],
      correctAnswer: 0
    },
    {
      id: 90215,
      question: "According to the evaluation section, why do older clients need to be re-evaluated more frequently and carefully?",
      options: [
        "Because insurance requires more frequent visits",
        "Because they request more appointments",
        "Because of the many physiologic changes, chronic conditions, and pathologic changes common in this age group",
        "Because they are less compliant with instructions"
      ],
      correctAnswer: 2
    },
    {
      id: 90216,
      question: "A dental hygienist may often be the first to notice which type of change over a series of appointments with an older client?",
      options: [
        "Cognitive declines",
        "Changes in favorite toothpaste brand",
        "Changes in home address",
        "Changes in insurance coverage"
      ],
      correctAnswer: 0
    },
    {
      id: 90217,
      question: "What quantitative measures are used to document healing and plan new interventions with older clients?",
      options: [
        "Weight and height only",
        "Vision and hearing test scores",
        "Blood pressure and pulse only",
        "Bleeding and plaque indices and pocket depth recording"
      ],
      correctAnswer: 3
    },
    {
      id: 90218,
      question: "In the case of Juan Hernandez (81-year-old male), which medication he takes is an anticoagulant that could increase bleeding risk during instrumentation?",
      options: [
        "Warfarin (Coumadin)",
        "Naproxen (Naproxsyn)",
        "Chlorothiazide (Diuril)",
        "Atorvastatin (Lipitor)"
      ],
      correctAnswer: 0
    },
    {
      id: 90219,
      question: "What is Juan Hernandez proud of regarding his dental history?",
      options: [
        "Having all of his teeth and never needing dentures",
        "Never having a cavity",
        "Having perfect radiographs",
        "Having straight teeth without orthodontics"
      ],
      correctAnswer: 0
    },
    {
      id: 90220,
      question: "What is Juan Hernandez's chief complaint at his visit?",
      options: [
        "Bleeding gums",
        "TMJ stiffness and a bilateral crackling sensation",
        "A broken denture",
        "Severe tooth pain"
      ],
      correctAnswer: 1
    },
    {
      id: 90221,
      question: "In Virginia Carson's case, what habit is identified as a deficit in 'protection from health risks'?",
      options: [
        "Overuse of mouthwash",
        "Tobacco usage",
        "Excessive flossing",
        "Frequent snacking"
      ],
      correctAnswer: 1
    },
    {
      id: 90222,
      question: "What dental appliance issue prompted Virginia Carson's dental hygiene appointment?",
      options: [
        "A missing crown",
        "A fractured ten-year-old partial denture and a new ill-fitting full maxillary denture",
        "A broken dental implant",
        "An orthodontic retainer that no longer fits"
      ],
      correctAnswer: 1
    },
    {
      id: 90223,
      question: "In Eleanor Gray's case, which of her medications creates a risk of osteonecrosis of the jaw, identified as a deficit in 'protection from health risks'?",
      options: [
        "Alendronate sodium (Fosamax)",
        "Donepezil (Aricept)",
        "Risperidone (Risperdal)",
        "Calcium carbonate supplement"
      ],
      correctAnswer: 0
    },
    {
      id: 90224,
      question: "What medical condition is Eleanor Gray being screened for participation in a clinical trial related to?",
      options: [
        "Alzheimer's disease progression",
        "Osteoporosis",
        "Congestive heart failure",
        "Chronic obstructive pulmonary disease"
      ],
      correctAnswer: 0
    },
    {
      id: 90225,
      question: "What behavior did Eleanor Gray display during her last dental visit that is noted as a deficit in 'freedom from fear and stress'?",
      options: [
        "She requested extra fluoride treatments",
        "She fell asleep during treatment",
        "She asked to reschedule for a shorter visit",
        "She became disruptive and refused treatment"
      ],
      correctAnswer: 3
    },
    {
      id: 90226,
      question: "Dental hygienists should generally attempt to completely change an older client's long-term home care habits rather than modify them.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90227,
      question: "Normal aging alterations may create a compromised oral situation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90228,
      question: "Individuals who receive antibiotic premedication should have care spread across many extra visits rather than as much care as possible at one time.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90229,
      question: "A dental hygienist's qualitative perception that 'something is not quite right' about an older client's cognition should be discussed with the client, relatives, and/or caregivers, with referral for further medical evaluation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90230,
      question: "In Virginia Carson's case, her physician's office noted she has halitosis and recommended she make a dental hygiene appointment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "4. Dental Care for Seniors": [
    {
      id: 90231,
      question: "What is the main goal of primary prevention in elderly care?",
      options: [
        "To stop disease before it begins by reducing risk factors",
        "To detect disease early before symptoms appear",
        "To manage disability once it has already occurred",
        "To treat an existing chronic disease and prevent further decline"
      ],
      correctAnswer: 0
    },
    {
      id: 90232,
      question: "Secondary prevention is best described as which of the following?",
      options: [
        "Providing hospice care during a terminal illness",
        "Managing a chronic disease to prevent further functional loss",
        "Reducing risk factors before any disease develops",
        "Detecting and treating disease early, before symptoms occur"
      ],
      correctAnswer: 3
    },
    {
      id: 90233,
      question: "Tertiary prevention primarily involves which approach?",
      options: [
        "Giving vaccinations to avoid disease onset",
        "Removing risk factors before disease appears",
        "Screening asymptomatic people for early disease",
        "Appropriately managing an existing chronic disease to prevent further loss"
      ],
      correctAnswer: 3
    },
    {
      id: 90234,
      question: "According to the material, screening can serve which dual purpose?",
      options: [
        "Only to measure a patient's overall fitness level",
        "To replace the need for any further preventive care",
        "To detect risk factors or to find disease in asymptomatic people",
        "Only to confirm a diagnosis after symptoms appear"
      ],
      correctAnswer: 2
    },
    {
      id: 90235,
      question: "Prevention efforts for the elderly mainly focus on which set of concerns?",
      options: [
        "Only chronic disease and nothing else",
        "Disease, frailty, accidents, iatrogenic complications, and psychosocial problems",
        "Only accident prevention in the home",
        "Only psychosocial and emotional concerns"
      ],
      correctAnswer: 1
    },
    {
      id: 90236,
      question: "For healthy elderly people with minimal chronic disease, which prevention is most beneficial?",
      options: [
        "Hospice and palliative planning only",
        "Primary and secondary prevention of disease and prevention of frailty",
        "Prevention of iatrogenic complications only",
        "Tertiary prevention of disease only"
      ],
      correctAnswer: 1
    },
    {
      id: 90237,
      question: "For chronically ill elderly patients, which preventive priorities are emphasized?",
      options: [
        "Only primary prevention of new diseases",
        "Secondary, tertiary, and iatrogenic prevention",
        "Only psychosocial support programs",
        "Only prevention of driving accidents"
      ],
      correctAnswer: 1
    },
    {
      id: 90238,
      question: "For frail or complex elderly patients, which type of prevention is most important?",
      options: [
        "Weight training for bone density",
        "Screening for early-stage disease only",
        "Prevention of accidents and iatrogenic complications",
        "Primary prevention of new chronic diseases"
      ],
      correctAnswer: 2
    },
    {
      id: 90239,
      question: "Which vaccinations are described as effective, inexpensive, and low in morbidity for the elderly?",
      options: [
        "Only annual pneumococcal vaccination",
        "Neither influenza nor pneumococcal vaccination",
        "Only a one-time influenza vaccination",
        "Yearly influenza and one-time pneumococcal vaccines"
      ],
      correctAnswer: 3
    },
    {
      id: 90240,
      question: "What does disease-specific care management involve?",
      options: [
        "A pharmacist reviewing medications independently",
        "A specially trained nurse coordinating protocol-driven care with a physician",
        "A hospital ward dedicated to surgical recovery",
        "A social worker managing housing arrangements"
      ],
      correctAnswer: 1
    },
    {
      id: 90241,
      question: "What is a key feature of chronic care clinics?",
      options: [
        "Patients with the same chronic disease are taught in groups and visited by a practitioner",
        "Patients are treated individually by a specialist only",
        "Patients receive care exclusively through home visits",
        "Patients are admitted for long-term hospitalization"
      ],
      correctAnswer: 0
    },
    {
      id: 90242,
      question: "When does referral to a specialist work best for a difficult-to-stabilize chronic disease?",
      options: [
        "When the specialist and primary care physician work collaboratively",
        "When the specialist manages care without informing the primary physician",
        "When the patient chooses to stop seeing the primary care physician",
        "When only diagnostic tests are needed, not treatment"
      ],
      correctAnswer: 0
    },
    {
      id: 90243,
      question: "Arthritis in the elderly increases the risk of which combination of problems?",
      options: [
        "Only medication side effects",
        "Only vision loss and hearing decline",
        "Osteoporosis, deconditioning, falls, and pressure ulcers",
        "Only depression and social isolation"
      ],
      correctAnswer: 2
    },
    {
      id: 90244,
      question: "How can osteoporosis progression be helped to prevent in older adults?",
      options: [
        "Relying solely on pain medication",
        "Increasing caffeine and reducing dairy intake",
        "Avoiding all forms of physical activity",
        "Bone density testing, calcium/vitamin D, exercise, and smoking cessation"
      ],
      correctAnswer: 3
    },
    {
      id: 90245,
      question: "What happens when the body's insulin does not work properly?",
      options: [
        "Glucose cannot enter cells and blood glucose levels rise",
        "The liver stops producing glucose entirely",
        "Muscle cells absorb glucose more efficiently",
        "Blood glucose levels drop dangerously low"
      ],
      correctAnswer: 0
    },
    {
      id: 90246,
      question: "For diabetic elderly patients, controlling which conditions is particularly important?",
      options: [
        "Only blood pressure, not cholesterol",
        "Vitamin D and calcium levels only",
        "Hypertension and dyslipidemia",
        "Only cholesterol, not blood pressure"
      ],
      correctAnswer: 2
    },
    {
      id: 90247,
      question: "How can risk from vascular disorders be reduced in elderly patients?",
      options: [
        "Limiting fluid intake only",
        "Avoiding all forms of medical treatment",
        "Focusing solely on dietary fiber intake",
        "Aggressively managing hypertension, smoking, and diabetes"
      ],
      correctAnswer: 3
    },
    {
      id: 90248,
      question: "Why is heart failure considered significant among the elderly?",
      options: [
        "Its mortality rate is higher than that of many cancers",
        "It has no effect on hospitalization rates",
        "It is easily cured with a single medication",
        "It rarely affects functional ability"
      ],
      correctAnswer: 0
    },
    {
      id: 90249,
      question: "Which strategies help decrease COPD exacerbations leading to hospitalization?",
      options: [
        "Smoking cessation, proper inhaler use, and energy-conserving education",
        "Avoiding all forms of patient education",
        "Increasing physical exertion without restriction",
        "Discontinuing all respiratory medications"
      ],
      correctAnswer: 0
    },
    {
      id: 90250,
      question: "Frailty is best defined as which of the following?",
      options: [
        "A permanent and irreversible cognitive decline",
        "An acute infection common in hospitals",
        "A specific chronic disease affecting only the lungs",
        "Loss of physiologic reserve, causing disability from minor stress"
      ],
      correctAnswer: 3
    },
    {
      id: 90251,
      question: "What lifestyle approach is recommended to prevent or reduce frailty?",
      options: [
        "Complete bed rest and minimal activity",
        "Regular aerobic exercise and a healthy diet",
        "A high-sugar, high-fat diet for energy",
        "Avoiding all forms of social interaction"
      ],
      correctAnswer: 1
    },
    {
      id: 90252,
      question: "What benefit does weight training provide for elderly people?",
      options: [
        "It has no measurable effect on bone health",
        "It increases bone mass and reduces risk of falls and fractures",
        "It increases risk of fractures over time",
        "It only benefits cardiovascular endurance"
      ],
      correctAnswer: 1
    },
    {
      id: 90253,
      question: "What should a falls prevention program include for high-risk elderly patients?",
      options: [
        "Only medication adjustments",
        "Complete restriction of all movement",
        "Exercise and vitamin D supplementation",
        "Only home relocation to a nursing home"
      ],
      correctAnswer: 2
    },
    {
      id: 90254,
      question: "Which conditions should prompt further assessment of an elderly person's driving ability?",
      options: [
        "Only a recent traffic ticket",
        "Only age above 65 with no other factors",
        "Only occasional difficulty parking",
        "Poor vision, dementia, impaired movement, and poor coordination"
      ],
      correctAnswer: 3
    },
    {
      id: 90255,
      question: "What hot water heater temperature helps prevent burns in elderly people with neuropathy?",
      options: [
        "Below 49°C",
        "Above 70°C",
        "Exactly 60°C",
        "There is no recommended temperature limit"
      ],
      correctAnswer: 0
    },
    {
      id: 90256,
      question: "Which factor increases the risk that treating one disease will worsen another in the elderly?",
      options: [
        "Having multiple chronic diseases at the same time",
        "Having only one mild chronic condition",
        "Living independently at home",
        "Attending regular exercise classes"
      ],
      correctAnswer: 0
    },
    {
      id: 90257,
      question: "What risk is associated with elderly patients seeing multiple physicians?",
      options: [
        "Elimination of iatrogenic complications",
        "Improved communication between all providers automatically",
        "Reduced need for medication management",
        "Uncoordinated care and polypharmacy"
      ],
      correctAnswer: 3
    },
    {
      id: 90258,
      question: "Which group of patients is at particularly high risk of adverse drug-drug or drug-disease interactions?",
      options: [
        "Patients who are undernourished or have renal failure",
        "Patients who live in assisted living facilities",
        "Patients who exercise regularly",
        "Patients who take no medications"
      ],
      correctAnswer: 0
    },
    {
      id: 90259,
      question: "Which patients are at high risk of iatrogenic complications during hospitalization?",
      options: [
        "Those who avoid all forms of surgery",
        "Those who are admitted for routine check-ups only",
        "Those who are discharged within a few hours",
        "Those with dementia or who are immobilized after surgery"
      ],
      correctAnswer: 3
    },
    {
      id: 90260,
      question: "Which of the following is an example of a medical-technology-related iatrogenic complication?",
      options: [
        "Improved mobility after physical therapy",
        "Stroke after carotid endarterectomy",
        "Reduced infection risk after vaccination",
        "Faster recovery after minor surgery"
      ],
      correctAnswer: 1
    },
    {
      id: 90261,
      question: "What is the role of a care manager in preventing iatrogenic complications?",
      options: [
        "Coordinating communication and preventing duplicated services",
        "Replacing the need for a primary care physician",
        "Performing surgery on complex cases",
        "Prescribing medications without physician input"
      ],
      correctAnswer: 0
    },
    {
      id: 90262,
      question: "When is a geriatric interdisciplinary team best reserved for use?",
      options: [
        "Only for patients with no chronic diseases",
        "For every elderly patient regardless of condition",
        "For very complex cases, since the intervention is resource-intensive",
        "Only for patients who are hospitalized briefly"
      ],
      correctAnswer: 2
    },
    {
      id: 90263,
      question: "What is the purpose of Acute Care for the Elderly (ACE) units?",
      options: [
        "To provide only long-term nursing home placement",
        "To evaluate elderly patients for potential iatrogenic problems before they occur",
        "To focus exclusively on surgical recovery",
        "To eliminate the need for advance directives"
      ],
      correctAnswer: 1
    },
    {
      id: 90264,
      question: "What is the main purpose of advance directives?",
      options: [
        "To assign a new primary care physician automatically",
        "To guarantee a patient will recover from illness",
        "To help prevent unwanted treatment for patients who cannot speak for themselves",
        "To replace the need for a care manager"
      ],
      correctAnswer: 2
    },
    {
      id: 90265,
      question: "Why is depression screening recommended for elderly patients?",
      options: [
        "Depression has no link to physical health",
        "Screening always requires a physician to administer",
        "Depression is common among the elderly and screening is relatively easy",
        "Depression rarely occurs in older adults"
      ],
      correctAnswer: 2
    },
    {
      id: 90266,
      question: "When does eldercare typically become necessary?",
      options: [
        "Only after a person is hospitalized",
        "Only when family members request it",
        "As soon as a person reaches a certain age",
        "When elders find it difficult to safely perform activities of daily living"
      ],
      correctAnswer: 3
    },
    {
      id: 90267,
      question: "How do static conditions like stroke typically differ from progressive conditions?",
      options: [
        "Static conditions always worsen over time",
        "Progressive conditions never affect daily functioning",
        "Static conditions are one-time events, while progressive conditions worsen over time",
        "There is no meaningful difference between them"
      ],
      correctAnswer: 2
    },
    {
      id: 90268,
      question: "What outcome is associated with effective multidisciplinary teamwork in patient care?",
      options: [
        "Increased conflict among care providers",
        "Slower decision-making with no added benefit",
        "Higher quality patient care and more innovation in treatment",
        "Reduced communication among professionals"
      ],
      correctAnswer: 2
    },
    {
      id: 90269,
      question: "What is a limitation of Telephone Call Assurance services for seniors?",
      options: [
        "They may not provide access to immediate medical attention",
        "They always include in-person medical checkups",
        "They require the senior to leave their home",
        "They cannot be scheduled or adjusted"
      ],
      correctAnswer: 0
    },
    {
      id: 90270,
      question: "What is a key concern when hiring companions or caregivers for seniors?",
      options: [
        "Ensuring they replace the senior's primary physician",
        "Ensuring they have no criminal record and are trustworthy",
        "Ensuring they only work night shifts",
        "Ensuring they provide medical diagnoses"
      ],
      correctAnswer: 1
    },
    {
      id: 90271,
      question: "What service do visiting nurses typically provide?",
      options: [
        "Medical care, rehabilitation, and hospice services in the patient's home",
        "Only transportation to appointments",
        "Only social companionship with no medical duties",
        "Only housekeeping and meal preparation"
      ],
      correctAnswer: 0
    },
    {
      id: 90272,
      question: "What is a notable drawback of Continuing Care Retirement Communities (CCRCs)?",
      options: [
        "They provide no long-term peace of mind",
        "They never offer a range of housing options",
        "They require seniors to move to a hospital",
        "They are usually expensive, even if extra care is never needed"
      ],
      correctAnswer: 3
    },
    {
      id: 90273,
      question: "What defines an Assisted Living Facility or Congregate Housing?",
      options: [
        "It focuses exclusively on rehabilitation after surgery",
        "It allows continued independence while providing some care and shared meals",
        "It requires seniors to live completely alone with no services",
        "It provides only full-time hospital-level medical care"
      ],
      correctAnswer: 1
    },
    {
      id: 90274,
      question: "What is a common concern associated with Long Term Care Homes (nursing homes)?",
      options: [
        "They provide no access to physicians or nurses",
        "They are always less expensive than home care",
        "Some seniors find them depressing, and care quality must be monitored",
        "They never have waiting lists for admission"
      ],
      correctAnswer: 2
    },
    {
      id: 90275,
      question: "How does OHIP typically cover dental care for seniors in Ontario?",
      options: [
        "It only covers dental care for seniors under age 65",
        "It covers some dental surgery that must be provided in a hospital due to medical necessity",
        "It provides no dental coverage under any circumstances",
        "It covers all routine dental office visits for every senior"
      ],
      correctAnswer: 1
    },
    {
      id: 90276,
      question: "Choice of preventive measures for elderly patients is guided by the patient's general condition, such as being healthy, chronically ill, or frail/complex.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90277,
      question: "Elderly people who engage in regular aerobic exercise generally show less functional decline than those who are sedentary.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90278,
      question: "Having multiple physicians always improves coordination of care for elderly patients.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90279,
      question: "Some municipalities in Ontario provide financial assistance for low-income seniors to help cover the cost of dental care.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90280,
      question: "According to the material, frailty and aging itself always require an elderly person to lose their independence.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
   "5. Elder Abuse & Neglect (Part 1)": [
    {
      id: 90281,
      question: "According to the World Health Organization, elder abuse occurs within any relationship where there is what?",
      options: [
        "an expectation of trust",
        "an expectation of friendship",
        "an expectation of employment",
        "an expectation of ownership"
      ],
      correctAnswer: 0
    },
    {
      id: 90282,
      question: "What term is used to describe both abuse and neglect together?",
      options: [
        "Exploitation",
        "Maltreatment",
        "Victimization",
        "Endangerment"
      ],
      correctAnswer: 1
    },
    {
      id: 90283,
      question: "How is \"abuse\" defined in the presentation?",
      options: [
        "Acts of omission failing to provide care",
        "Assumptions based on someone's age",
        "Violent physical, sexual, emotional, or verbal acts",
        "Unintentional harm from poor judgment"
      ],
      correctAnswer: 2
    },
    {
      id: 90284,
      question: "How is \"neglect\" defined in the presentation?",
      options: [
        "Violent physical or verbal acts",
        "Assumptions based on someone's age",
        "Deliberate financial exploitation",
        "Acts of omission, failure to provide care"
      ],
      correctAnswer: 3
    },
    {
      id: 90285,
      question: "Assuming an older person is forgetful or can't understand technology simply because of their age is an example of what concept?",
      options: [
        "Ageism",
        "Neglect",
        "Maltreatment",
        "Self-neglect"
      ],
      correctAnswer: 0
    },
    {
      id: 90286,
      question: "According to global estimates, approximately how many older adults worldwide have been abused in the past year?",
      options: [
        "1 in 3",
        "1 in 6",
        "1 in 10",
        "1 in 20"
      ],
      correctAnswer: 1
    },
    {
      id: 90287,
      question: "Contrary to a common myth, where does elder abuse most often occur?",
      options: [
        "In hospitals and clinics",
        "In nursing homes mostly",
        "At home, behind closed doors",
        "In public community centers"
      ],
      correctAnswer: 2
    },
    {
      id: 90288,
      question: "Contrary to a common myth, who most often abuses vulnerable older adults?",
      options: [
        "Strangers on the street",
        "Paid professional caregivers",
        "Untrained volunteer workers",
        "A known, trusted family member"
      ],
      correctAnswer: 3
    },
    {
      id: 90289,
      question: "Why do most cases of elder abuse not result in criminal prosecution?",
      options: [
        "Most victims don't tell anyone",
        "Police lack proper training",
        "Courts dismiss most cases",
        "Laws don't clearly define abuse"
      ],
      correctAnswer: 0
    },
    {
      id: 90290,
      question: "Regardless of gender, which group is at greatest risk of being abused?",
      options: [
        "Those who live independently",
        "Those with cognitive impairment",
        "Those who are financially wealthy",
        "Those with large social networks"
      ],
      correctAnswer: 1
    },
    {
      id: 90291,
      question: "According to the myths section, what are the most common types of elder abuse?",
      options: [
        "Physical abuse and assault",
        "Sexual abuse and coercion",
        "Neglect and self-neglect",
        "Institutional confinement"
      ],
      correctAnswer: 2
    },
    {
      id: 90292,
      question: "What does the presentation say about caregiver stress and elder abuse?",
      options: [
        "Caregiver stress justifies harsh discipline",
        "Caregiver stress is the main legal defense",
        "Caregiver stress always leads to abuse",
        "Caregiver stress does not excuse abuse"
      ],
      correctAnswer: 3
    },
    {
      id: 90293,
      question: "According to the National Center on Elder Abuse, how many elderly Americans experience some form of abuse each year?",
      options: [
        "Two to five million",
        "Ten to twenty million",
        "Five hundred thousand",
        "Fewer than one hundred thousand"
      ],
      correctAnswer: 0
    },
    {
      id: 90294,
      question: "For every one reported case of elder abuse, approximately how many more go unreported?",
      options: [
        "About one more case",
        "About five more cases",
        "About ten more cases",
        "About twenty more cases"
      ],
      correctAnswer: 1
    },
    {
      id: 90295,
      question: "Which of the following is NOT one of the four core types of abuse discussed?",
      options: [
        "Neglect",
        "Physical abuse",
        "Retirement planning",
        "Sexual abuse"
      ],
      correctAnswer: 2
    },
    {
      id: 90296,
      question: "Besides elderly people, which other groups are commonly identified as abuse victims?",
      options: [
        "Teachers and coworkers",
        "Tourists and neighbors",
        "Students and employers",
        "Infants/children and intimate partners"
      ],
      correctAnswer: 3
    },
    {
      id: 90297,
      question: "Which of the following describes physical abuse?",
      options: [
        "Hitting, pushing, or inappropriate use of restraints",
        "Insults, threats, and controlling behavior",
        "Misusing or stealing a person's assets",
        "Not providing food, housing, or medical care"
      ],
      correctAnswer: 0
    },
    {
      id: 90298,
      question: "Which of the following describes psychological or emotional abuse?",
      options: [
        "Hitting, pushing, or kicking someone",
        "Insults, threats, humiliation, and confinement",
        "Sexual contact without consent given",
        "Stealing money from a bank account"
      ],
      correctAnswer: 1
    },
    {
      id: 90299,
      question: "How is sexual abuse of an older adult defined?",
      options: [
        "Misusing a person's money or assets",
        "Not providing housing or medical care",
        "Sexual contact without a person's consent",
        "Insulting or humiliating an older adult"
      ],
      correctAnswer: 2
    },
    {
      id: 90300,
      question: "How is financial exploitation defined?",
      options: [
        "Sexual contact without consent given",
        "Not providing food, housing, or care",
        "Hitting, pushing, or using restraints",
        "Misusing or stealing a person's money"
      ],
      correctAnswer: 3
    },
    {
      id: 90301,
      question: "How is neglect or abandonment defined?",
      options: [
        "Not providing food, housing, or medical care",
        "Insulting or humiliating an older person",
        "Misusing or stealing financial assets",
        "Sexual contact without a person's consent"
      ],
      correctAnswer: 0
    },
    {
      id: 90302,
      question: "Which is a physical indicator that can suggest abuse is occurring?",
      options: [
        "Consistent, well-documented medical history",
        "Injuries inconsistent with the given explanation",
        "Regular visits to a primary care doctor",
        "Steady weight gain over several months"
      ],
      correctAnswer: 1
    },
    {
      id: 90303,
      question: "Which behavioral sign shown by a victim may indicate possible abuse?",
      options: [
        "Increased participation in social activities",
        "Calm, confident, and open communication",
        "Contradictory statements about their injuries",
        "Consistent, detailed medical explanations"
      ],
      correctAnswer: 2
    },
    {
      id: 90304,
      question: "Which pattern is often seen in caretakers who abuse?",
      options: [
        "Encouraging the victim's independence",
        "Welcoming frequent visitors and outings",
        "Providing consistent caregiver training",
        "Preventing the victim from seeing visitors"
      ],
      correctAnswer: 3
    },
    {
      id: 90305,
      question: "People who commit elder abuse are often in what kind of position relative to the victim?",
      options: [
        "A position of trust with the victim",
        "A position of financial wealth",
        "A position within law enforcement",
        "A position of complete anonymity"
      ],
      correctAnswer: 0
    },
    {
      id: 90306,
      question: "Which of the following is listed as a risk factor for committing elder abuse?",
      options: [
        "Strong social support and low stress",
        "Substance abuse and high stress levels",
        "Extensive caregiver training and rest",
        "Financial independence from the victim"
      ],
      correctAnswer: 1
    },
    {
      id: 90307,
      question: "Which sign may indicate that a vulnerable person is being financially exploited?",
      options: [
        "Consistent, unchanged spending patterns",
        "Regular, well-documented bank statements",
        "Frequent checks made out to \"cash\"",
        "Steady growth in retirement savings"
      ],
      correctAnswer: 2
    },
    {
      id: 90308,
      question: "Which is a general manifestation of maltreatment mentioned in the presentation?",
      options: [
        "Consistent school or medical attendance",
        "Improved hygiene and social confidence",
        "Increased appetite and healthy weight",
        "Bruises in multiple stages of healing"
      ],
      correctAnswer: 3
    },
    {
      id: 90309,
      question: "Which body part is described as the most common site for oral injuries related to abuse?",
      options: [
        "The lips",
        "The gingiva",
        "The tongue",
        "The molars"
      ],
      correctAnswer: 0
    },
    {
      id: 90310,
      question: "What does dental neglect commonly manifest as?",
      options: [
        "Excessive orthodontic treatment visits",
        "Poor oral hygiene and untreated caries",
        "Overuse of professional whitening",
        "Frequent unnecessary dental cleanings"
      ],
      correctAnswer: 1
    },
    {
      id: 90311,
      question: "Physical findings that are mistaken for abuse may be caused by which of the following?",
      options: [
        "Regular exercise and healthy sleep habits",
        "Consistent nutrition and hydration levels",
        "Genetic, infectious, or cultural conditions",
        "Strong family communication patterns"
      ],
      correctAnswer: 2
    },
    {
      id: 90312,
      question: "What term describes the use of force or coercion to abuse or intimidate others?",
      options: [
        "Failure to provide adequate basic care",
        "Misusing an older person's finances",
        "Assumptions made based on someone's age",
        "Using force or coercion to intimidate others"
      ],
      correctAnswer: 3
    },
    {
      id: 90313,
      question: "Domestic violence/intimate partner violence (IPV) is a pattern of abusive behavior used for what purpose?",
      options: [
        "To gain or maintain power and control",
        "To improve household communication",
        "To provide financial support and stability",
        "To strengthen community social ties"
      ],
      correctAnswer: 0
    },
    {
      id: 90314,
      question: "How is domestic elder abuse defined?",
      options: [
        "Abuse occurring in residential facilities",
        "Maltreatment by someone with a relationship, at home",
        "Harm caused by one's own neglectful behavior",
        "Force or coercion used to intimidate others"
      ],
      correctAnswer: 1
    },
    {
      id: 90315,
      question: "How is institutional abuse defined?",
      options: [
        "Maltreatment by a family member at home",
        "Harm caused by one's own neglectful behavior",
        "Abuse occurring in residential care facilities",
        "Use of coercion to intimidate a partner"
      ],
      correctAnswer: 2
    },
    {
      id: 90316,
      question: "How is self-neglect defined?",
      options: [
        "Abuse occurring in residential care facilities",
        "Maltreatment by a relative in the home",
        "Force or coercion used against another",
        "Harm caused by one's own neglectful behavior"
      ],
      correctAnswer: 3
    },
    {
      id: 90317,
      question: "According to prevalence data, approximately what percentage of elder abusers are family members?",
      options: [
        "90%",
        "70%",
        "50%",
        "30%"
      ],
      correctAnswer: 0
    },
    {
      id: 90318,
      question: "Among older people in institutions, which type of abuse is reported most often?",
      options: [
        "Sexual abuse",
        "Psychological abuse",
        "Financial abuse",
        "Physical neglect"
      ],
      correctAnswer: 1
    },
    {
      id: 90319,
      question: "What percentage of elder abuse is estimated to actually be reported?",
      options: [
        "25%",
        "15%",
        "4%",
        "40%"
      ],
      correctAnswer: 2
    },
    {
      id: 90320,
      question: "What did a U.S. study tracking older people over 13 years find about victims of elder abuse?",
      options: [
        "They lived longer than non-abused peers",
        "They reported greater life satisfaction",
        "They experienced fewer chronic conditions",
        "They were twice as likely to die prematurely"
      ],
      correctAnswer: 3
    },
    {
      id: 90321,
      question: "What proportion of people with dementia have been found to experience abuse?",
      options: [
        "About two out of three people with dementia",
        "About one out of ten people with dementia",
        "About one out of five people with dementia",
        "About one out of two people with dementia"
      ],
      correctAnswer: 0
    },
    {
      id: 90322,
      question: "According to prevention guidance, what should older people do to help protect themselves?",
      options: [
        "Avoid contact with family and friends",
        "Make sure financial and legal affairs are in order",
        "Refuse all professional support services",
        "Keep personal information completely private"
      ],
      correctAnswer: 1
    },
    {
      id: 90323,
      question: "What can family and informal caregivers do to lower their risk of committing abuse?",
      options: [
        "Increase caregiving hours without rest",
        "Avoid seeking outside support services",
        "Take breaks and get support from services",
        "Limit communication with other family members"
      ],
      correctAnswer: 2
    },
    {
      id: 90324,
      question: "Which is a strategy the health sector/government can use to address elder abuse?",
      options: [
        "Reduce awareness campaigns in health sectors",
        "Ignore reports of suspected elder abuse",
        "Limit collaboration between different sectors",
        "Develop and test evidence-based interventions"
      ],
      correctAnswer: 3
    },
    {
      id: 90325,
      question: "If an older adult's safety is in immediate danger, what should be done according to the reporting flowchart?",
      options: [
        "Call the police or EMS at 911",
        "Contact the Seniors Safety Line",
        "Call the LongTerm Care ACTION Line",
        "Reach out to Crime Stoppers"
      ],
      correctAnswer: 0
    },
    {
      id: 90326,
      question: "Elder abuse is more likely to be committed by strangers than by family members or trusted caregivers.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90327,
      question: "According to the WHO, elder abuse can result from intentional or unintentional neglect.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90328,
      question: "Only visible physical injuries, such as bruises or broken bones, indicate that elder abuse has occurred.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90329,
      question: "Elder abuse can occur in both private homes and institutional settings such as nursing homes.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90330,
      question: "A suspected non-emergency elder abuse situation should always be reported by immediately calling 911.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
   "5. Elder Abuse & Neglect (Part 2)": [
    {
      id: 90331,
      question: "In 2006, what percentage of Canada's total population did seniors represent?",
      options: [
        "13.2%",
        "24.5%",
        "9.8%",
        "4.2%"
      ],
      correctAnswer: 0
    },
    {
      id: 90332,
      question: "By 2036, what proportion of Canada's population is expected to be seniors?",
      options: [
        "13.2%",
        "24.5%",
        "9.8%",
        "4.2%"
      ],
      correctAnswer: 1
    },
    {
      id: 90333,
      question: "The fastest-growing senior group, those over age 80, is expected to increase across what range between 2021 and 2056?",
      options: [
        "5.8% to 13.2%",
        "4.2% to 9.8%",
        "2.1% to 5.8%",
        "1.5% to 4.2%"
      ],
      correctAnswer: 2
    },
    {
      id: 90334,
      question: "What factors are attributed to the increasing proportion of seniors in Canada?",
      options: [
        "Improved dental care and rising incomes",
        "Decreased edentulism and disposable income",
        "Increased awareness of oral-systemic links",
        "Decreasing birth rate and increased life expectancy"
      ],
      correctAnswer: 3
    },
    {
      id: 90335,
      question: "Besides demographic shifts, why is the number of elderly seeking dental care expected to increase?",
      options: [
        "Decreased edentulism and increased disposable income",
        "Decreasing birth rate and aging baby boomers",
        "Increased life expectancy and lower fertility",
        "Rising proportion of seniors over age 80"
      ],
      correctAnswer: 0
    },
    {
      id: 90336,
      question: "How is elder abuse defined in this article?",
      options: [
        "Only physical injuries caused by a stranger",
        "Hurtful acts of commission or omission by a person in trust",
        "Financial exploitation committed by scam artists",
        "Neglect caused solely by inexperienced caregivers"
      ],
      correctAnswer: 1
    },
    {
      id: 90337,
      question: "The hurtful act in elder abuse is considered to be one that is what?",
      options: [
        "Purely accidental and unintentional",
        "Limited to physical harm only",
        "Intentional, willful, or non-accidental",
        "Always committed by a stranger"
      ],
      correctAnswer: 2
    },
    {
      id: 90338,
      question: "Who developed the original validated template used to help physicians recognize elder abuse?",
      options: [
        "Michael Wiseman",
        "The Canadian Dental Association",
        "Lachs and Pillemer",
        "Bomba"
      ],
      correctAnswer: 3
    },
    {
      id: 90339,
      question: "In 1981, the U.S. Congress Select Committee on Aging estimated what percentage of American elderly were victims of abuse?",
      options: [
        "5%",
        "10%",
        "20%",
        "29%"
      ],
      correctAnswer: 0
    },
    {
      id: 90340,
      question: "According to international studies cited, the estimated rate of elder abuse ranges from what?",
      options: [
        "1% to 5%",
        "2% to 10%",
        "10% to 20%",
        "20% to 30%"
      ],
      correctAnswer: 1
    },
    {
      id: 90341,
      question: "One Israeli study indicated that the rate of elder abuse could be as high as what?",
      options: [
        "5%",
        "10%",
        "20%",
        "30%"
      ],
      correctAnswer: 2
    },
    {
      id: 90342,
      question: "In 2003, how many incidents of violence against seniors were reported in Canada?",
      options: [
        "400",
        "1,500",
        "2,900",
        "4,000"
      ],
      correctAnswer: 3
    },
    {
      id: 90343,
      question: "Of the 2003 Canadian violence incidents against seniors, what percentage were committed by a family member?",
      options: [
        "29%",
        "15%",
        "50%",
        "90%"
      ],
      correctAnswer: 0
    },
    {
      id: 90344,
      question: "According to the article, where did most physical abuse incidents against seniors take place?",
      options: [
        "In hospitals",
        "In the home",
        "In long-term care facilities",
        "In public settings"
      ],
      correctAnswer: 1
    },
    {
      id: 90345,
      question: "In the United States, the rate of elder abuse was estimated to have increased by what percentage between 1986 and 1996?",
      options: [
        "50%",
        "100%",
        "150%",
        "200%"
      ],
      correctAnswer: 2
    },
    {
      id: 90346,
      question: "Which of the following is listed as a general sign raising suspicion of elder abuse in the dental template?",
      options: [
        "Regular dental checkups every six months",
        "Consistent history from patient and caregiver",
        "Radiographic results consistent with history",
        "Functionally impaired patient without caregiver"
      ],
      correctAnswer: 3
    },
    {
      id: 90347,
      question: "What term describes an abuse warning sign where a patient frequently changes health care providers?",
      options: [
        "Physician/dentist hopping",
        "Provider avoidance syndrome",
        "Caregiver rotation pattern",
        "Appointment inconsistency"
      ],
      correctAnswer: 0
    },
    {
      id: 90348,
      question: "Which of the following is listed as a sign of physical abuse in the template?",
      options: [
        "Sense of hopelessness and resignation",
        "Bruises, welts, cuts, or burn marks",
        "Unexplained changes to a will",
        "Untreated dental caries"
      ],
      correctAnswer: 1
    },
    {
      id: 90349,
      question: "Which of the following is listed as a sign of psychological abuse in the template?",
      options: [
        "Avulsed or loose teeth",
        "Missing cheques or money",
        "Fearful, tearful, or clinging behaviour",
        "Long-term use of fractured dentures"
      ],
      correctAnswer: 2
    },
    {
      id: 90350,
      question: "Which of the following is listed as a sign of neglect in the template?",
      options: [
        "Laceration of the labial frenum",
        "Unexplained power of attorney changes",
        "Painful body movements unrelated to illness",
        "Underweight, frail, and dehydrated appearance"
      ],
      correctAnswer: 3
    },
    {
      id: 90351,
      question: "Which of the following is listed as a sign of financial exploitation in the template?",
      options: [
        "Unexplained decrease in a bank account",
        "Bruises at varying stages of healing",
        "Passive, helpless, or withdrawn behaviour",
        "Palatal petechiae or torn labial frenum"
      ],
      correctAnswer: 0
    },
    {
      id: 90352,
      question: "Which of the following is listed as a sign of sexual abuse in the template?",
      options: [
        "Unclean appearance and excessive plaque",
        "Laceration of the labial frenum or palatal petechiae",
        "Missing belongings or bounced cheques",
        "Blood on the person's clothes"
      ],
      correctAnswer: 1
    },
    {
      id: 90353,
      question: "What is the first step in the management and monitoring decision tree for suspected elder abuse?",
      options: [
        "Refer the patient to a geriatric team",
        "Interview the caregiver alone",
        "Assess for safety and immediate danger",
        "Arrange a follow-up appointment"
      ],
      correctAnswer: 2
    },
    {
      id: 90354,
      question: "According to the decision tree, what should happen if a patient is in immediate danger?",
      options: [
        "Schedule a follow-up visit",
        "Refer to financial management services",
        "Use gentle persuasion techniques",
        "Make an immediate referral to police"
      ],
      correctAnswer: 3
    },
    {
      id: 90355,
      question: "If a patient lacks the capacity to refuse treatment, what possible actions are listed?",
      options: [
        "Financial management, guardianship, or court proceedings",
        "Immediate referral to the police only",
        "Providing emergency information only",
        "Educating the patient and arranging follow-up only"
      ],
      correctAnswer: 0
    },
    {
      id: 90356,
      question: "According to Figure 2, what must health care professionals balance regarding vulnerable elders?",
      options: [
        "Cost of care versus family preference",
        "Duty to protect safety versus right to self-determination",
        "Legal liability versus professional reputation",
        "Speed of treatment versus thoroughness of care"
      ],
      correctAnswer: 1
    },
    {
      id: 90357,
      question: "Which value is emphasized when treating elders, according to Figure 2?",
      options: [
        "Efficiency and speed of treatment",
        "Strict adherence to institutional policy",
        "Honesty, compassion, and respect",
        "Minimizing family involvement"
      ],
      correctAnswer: 2
    },
    {
      id: 90358,
      question: "Which is listed as a right of older adults in the article?",
      options: [
        "The right to have all decisions made by family",
        "The right to be placed in institutional care",
        "The right to be shielded from all information",
        "The right to accept or refuse services"
      ],
      correctAnswer: 3
    },
    {
      id: 90359,
      question: "Which is listed as a best practice guideline for managing suspected elder abuse?",
      options: [
        "First, do no harm",
        "Always report to police immediately",
        "Impose personal values on the patient",
        "Prioritize institutional care over community care"
      ],
      correctAnswer: 0
    },
    {
      id: 90360,
      question: "Which is an example screening question suggested for suspected elder abuse?",
      options: [
        "\"Do you enjoy visiting the dentist?\"",
        "\"Are you afraid of anyone in your family?\"",
        "\"How often do you brush your teeth?\"",
        "\"Do you have dental insurance coverage?\""
      ],
      correctAnswer: 1
    },
    {
      id: 90361,
      question: "According to the article, abuse can take which of the following forms?",
      options: [
        "Only physical and financial abuse",
        "Only neglect and emotional abuse",
        "Physical, emotional, sexual, financial abuse, or neglect",
        "Only sexual and psychological abuse"
      ],
      correctAnswer: 2
    },
    {
      id: 90362,
      question: "How is physical abuse defined in the article?",
      options: [
        "Failure to provide necessary goods or services",
        "Nonconsensual sexual contact of any kind",
        "Intimidation, humiliation, or belittling",
        "Injury or harm causing pain, suffering, or impairment"
      ],
      correctAnswer: 3
    },
    {
      id: 90363,
      question: "What may scarring or bruising of the wrists indicate?",
      options: [
        "Physical restraint",
        "Natural aging changes",
        "Blood-thinning medication use",
        "Poor oral hygiene"
      ],
      correctAnswer: 0
    },
    {
      id: 90364,
      question: "How is emotional abuse defined in the article?",
      options: [
        "Withholding food, shelter, or medical care",
        "Intimidation, humiliation, belittling, or threats",
        "Nonconsensual sexual contact",
        "Misuse of a senior's financial assets"
      ],
      correctAnswer: 1
    },
    {
      id: 90365,
      question: "How is sexual abuse defined in the article?",
      options: [
        "Failure to provide necessary care",
        "Financial exploitation by a caregiver",
        "Nonconsensual sexual contact of any kind",
        "Intimidation or threats of abandonment"
      ],
      correctAnswer: 2
    },
    {
      id: 90366,
      question: "How is neglect defined in the article?",
      options: [
        "Intentional physical harm causing injury",
        "Nonconsensual sexual contact of any kind",
        "Intimidation and humiliation of a senior",
        "Failure to provide goods or services necessary to function"
      ],
      correctAnswer: 3
    },
    {
      id: 90367,
      question: "What distinguishes active neglect from passive neglect?",
      options: [
        "Active neglect is intentional; passive results from lack of ability",
        "Active neglect is accidental; passive is deliberate",
        "Active neglect only involves finances; passive involves food",
        "Active neglect is legal; passive neglect is illegal"
      ],
      correctAnswer: 0
    },
    {
      id: 90368,
      question: "Which is NOT one of the three types of financial abuse perpetrators described in the article?",
      options: [
        "A person of trust motivated by greed",
        "A random stranger with no relationship to the senior",
        "A family member who feels entitled to the estate",
        "A scam artist using false promises"
      ],
      correctAnswer: 1
    },
    {
      id: 90369,
      question: "Which characteristic was identified as increasing a caregiver's potential for abuse?",
      options: [
        "Living independently from the dependent senior",
        "Having extensive caregiving experience",
        "Feeling isolated and lacking community support",
        "Having no other caregiving responsibilities"
      ],
      correctAnswer: 2
    },
    {
      id: 90370,
      question: "Why might an abused elder deny that abuse is occurring?",
      options: [
        "They do not understand what abuse means",
        "They believe the dentist cannot help them",
        "They are unaware of reporting procedures",
        "They fear retaliation or feel shame"
      ],
      correctAnswer: 3
    },
    {
      id: 90371,
      question: "Which characteristic is commonly seen in abused elderly patients?",
      options: [
        "Submissive or withdrawn behaviour near their caregiver",
        "Excessive independence from their caregiver",
        "Frequent complaints about their caregiver",
        "Consistent, detailed explanations of injuries"
      ],
      correctAnswer: 0
    },
    {
      id: 90372,
      question: "Why are dentists well-positioned to screen for elder abuse?",
      options: [
        "They have specialized legal training in abuse law",
        "They see patients twice yearly and examine the head and neck",
        "They are required to conduct home visits",
        "They have access to a patient's full financial records"
      ],
      correctAnswer: 1
    },
    {
      id: 90373,
      question: "How should a dentist's conversation with a suspected abuse victim take place?",
      options: [
        "With the caregiver present for support",
        "In the waiting room for convenience",
        "In a private area, witnessed by another staff member",
        "Only through written correspondence"
      ],
      correctAnswer: 2
    },
    {
      id: 90374,
      question: "Which natural aging-related factor should a dentist consider before suspecting abuse?",
      options: [
        "Increased participation in social activities",
        "Improved communication skills over time",
        "Decreased need for medication review",
        "Thinning skin and bruising from blood thinners"
      ],
      correctAnswer: 3
    },
    {
      id: 90375,
      question: "What is one barrier that may affect a dentist's willingness to report suspected elder abuse?",
      options: [
        "Uncertainty about the diagnosis and legal responsibility",
        "Lack of access to a dental chair",
        "Excessive confidence in every diagnosis",
        "Overly clear provincial reporting laws"
      ],
      correctAnswer: 0
    },
    {
      id: 90376,
      question: "In which Canadian province is reporting of elder abuse and neglect mandatory?",
      options: [
        "Ontario",
        "Nova Scotia",
        "British Columbia",
        "Quebec"
      ],
      correctAnswer: 1
    },
    {
      id: 90377,
      question: "In Newfoundland and Labrador, mandatory reporting applies to which situation?",
      options: [
        "Both abuse and neglect equally",
        "Neither abuse nor neglect",
        "Neglect, but not abuse",
        "Abuse, but not neglect"
      ],
      correctAnswer: 2
    },
    {
      id: 90378,
      question: "Which provinces have legislated voluntary (not mandatory) reporting of elder abuse?",
      options: [
        "Ontario and Nova Scotia",
        "Quebec and Newfoundland",
        "Alberta and Manitoba",
        "Prince Edward Island, New Brunswick, and British Columbia"
      ],
      correctAnswer: 3
    },
    {
      id: 90379,
      question: "The Ontario Long-Term Care Homes Act (2006) establishes mandatory reporting of abuse in what setting?",
      options: [
        "Long-term care centres only",
        "All dental offices",
        "Private homes only",
        "Hospitals only"
      ],
      correctAnswer: 0
    },
    {
      id: 90380,
      question: "In Quebec, how are suspected elder abuse cases primarily addressed?",
      options: [
        "Through a dedicated elder abuse reporting law",
        "Through existing criminal code protections against assault and fraud",
        "Through mandatory reporting by all professionals",
        "Through voluntary reporting only in long-term care"
      ],
      correctAnswer: 1
    },
    {
      id: 90381,
      question: "What is the position of the Elder Abuse Prevention Unit in Queensland, Australia, regarding mandatory reporting?",
      options: [
        "It strongly supports mandatory reporting nationwide",
        "It has no opinion on mandatory reporting",
        "It believes mandatory reporting may not improve safety and denies senior autonomy",
        "It requires reporting only for financial abuse"
      ],
      correctAnswer: 2
    },
    {
      id: 90382,
      question: "What does the Canadian Network for the Prevention of Elder Abuse state about mentally capable seniors?",
      options: [
        "They should always be reported regardless of wishes",
        "They require guardianship in all cases",
        "They cannot make decisions about their own safety",
        "They have the right to live as they choose if mentally capable"
      ],
      correctAnswer: 3
    },
    {
      id: 90383,
      question: "According to Table 1, what dental/head-and-neck manifestation is associated with hair pulling?",
      options: [
        "Unusual loss of hair in the head and neck area",
        "Fractured or avulsed teeth",
        "Palatal bruising or petechiae",
        "Abundant plaque and food debris"
      ],
      correctAnswer: 0
    },
    {
      id: 90384,
      question: "According to Table 1, which dental-related sign may indicate financial exploitation?",
      options: [
        "Torn labial frenum",
        "Caregiver refuses to pay for basic dental care",
        "Facial contusions and swollen lips",
        "Muscle trismus"
      ],
      correctAnswer: 1
    },
    {
      id: 90385,
      question: "Elder abuse only affects people of certain races or social classes.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90386,
      question: "Dentists typically see their patients more frequently than physicians do, which places them in a good position to notice signs of abuse.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90387,
      question: "According to the article, neglect can only be intentional and is never the result of a caregiver's lack of experience.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90388,
      question: "In Canada, the legal requirement for dentists to report elder abuse is uniform across all provinces and territories.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90389,
      question: "Abused elderly patients often deny being abused due to fear, shame, or a sense of helplessness.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90390,
      question: "The Canadian Network for the Prevention of Elder Abuse supports mandatory reporting for all mentally capable seniors, regardless of their wishes.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
   "6. Communicating with Older Adults (Part 1)": [
    {
      id: 90391,
      question: "How many Americans were 65 years of age or older in 2010, according to the report?",
      options: [
        "40.4 million",
        "35 million",
        "55 million",
        "72.1 million"
      ],
      correctAnswer: 0
    },
    {
      id: 90392,
      question: "By what year is the older population projected to reach 72.1 million?",
      options: [
        "2020",
        "2030",
        "2040",
        "2025"
      ],
      correctAnswer: 1
    },
    {
      id: 90393,
      question: "What percentage of noninstitutionalized older adults reported their health as excellent or very good (2000-2009)?",
      options: [
        "25%",
        "55%",
        "40%",
        "65%"
      ],
      correctAnswer: 2
    },
    {
      id: 90394,
      question: "On average, how many physician office visits per year do older adults make?",
      options: [
        "3.7 visits",
        "5.2 visits",
        "9.4 visits",
        "7.1 visits"
      ],
      correctAnswer: 3
    },
    {
      id: 90395,
      question: "According to the American Society of Consultant Pharmacists, how many prescription medications do adults 80 to 84 years of age take on average per year?",
      options: [
        "18 medications",
        "10 medications",
        "22 medications",
        "14 medications"
      ],
      correctAnswer: 0
    },
    {
      id: 90396,
      question: "What happens to most aspects of language ability as people age, according to the report?",
      options: [
        "Vocabulary and comprehension decline steadily",
        "There is no evidence of decline; vocabulary may improve",
        "Verbal comprehension deteriorates significantly",
        "Sentence production becomes more complex"
      ],
      correctAnswer: 1
    },
    {
      id: 90397,
      question: "What is \"crystallized intelligence\"?",
      options: [
        "The speed at which new information is processed",
        "The capacity for short-term memory storage",
        "The knowledge acquired through education and experience",
        "The ability to multitask under pressure"
      ],
      correctAnswer: 2
    },
    {
      id: 90398,
      question: "What is the estimated prevalence of significant hearing impairment among people 75 years of age or older?",
      options: [
        "10% to 15%",
        "20% to 25%",
        "60% to 65%",
        "40% to 50%"
      ],
      correctAnswer: 3
    },
    {
      id: 90399,
      question: "What is presbycusis?",
      options: [
        "Age-related hearing loss focused in high-frequency areas",
        "A vision condition affecting near-focus ability",
        "A form of dementia affecting memory recall",
        "A speech disorder affecting sentence production"
      ],
      correctAnswer: 0
    },
    {
      id: 90400,
      question: "What is the most common vision problem among adults older than 55 years of age?",
      options: [
        "Cataracts",
        "Presbyopia",
        "Glaucoma",
        "Macular degeneration"
      ],
      correctAnswer: 1
    },
    {
      id: 90401,
      question: "What may be the first sign of a cataract, according to the report?",
      options: [
        "Difficulty reading small print",
        "Trouble hearing high-pitched sounds",
        "Substantial difficulty with night driving",
        "Difficulty recalling names"
      ],
      correctAnswer: 2
    },
    {
      id: 90402,
      question: "What is a consequence of reduced peripheral vision in older adults, per the report?",
      options: [
        "Improved balance while walking",
        "Increased sensitivity to bright light",
        "Enhanced depth perception",
        "Limited social interaction with people nearby"
      ],
      correctAnswer: 3
    },
    {
      id: 90403,
      question: "Age-related changes in language comprehension are largely attributable to a decline in which system?",
      options: [
        "Working memory",
        "Long-term memory",
        "Semantic memory",
        "Procedural memory"
      ],
      correctAnswer: 0
    },
    {
      id: 90404,
      question: "What type of information do older adults typically have more difficulty retrieving from long-term memory?",
      options: [
        "General knowledge",
        "People's names",
        "Vocabulary",
        "Family history"
      ],
      correctAnswer: 1
    },
    {
      id: 90405,
      question: "According to Recommendation 1, what should you do to avoid relying on stereotypes when meeting an older adult?",
      options: [
        "Speak louder immediately to test hearing ability",
        "Assume the person has cognitive decline until proven otherwise",
        "Ask a few simple questions early on to assess the person's actual abilities",
        "Rely on physical appearance to guide the conversation"
      ],
      correctAnswer: 2
    },
    {
      id: 90406,
      question: "What is \"elderspeak\"?",
      options: [
        "A dialect commonly used among older adults",
        "A medical term for age-related hearing loss",
        "A technique used to teach older patients new vocabulary",
        "A patronizing speech style using simplified words and exaggerated tone"
      ],
      correctAnswer: 3
    },
    {
      id: 90407,
      question: "What effect can \"elderspeak\" have on older adults with Alzheimer's disease?",
      options: [
        "It can lead to more resistance to care and aggressive behavior",
        "It improves compliance with care",
        "It has no measurable effect",
        "It significantly boosts their mood and cooperation"
      ],
      correctAnswer: 0
    },
    {
      id: 90408,
      question: "What is recommended instead of using terms of endearment or simplified vocabulary with older adults?",
      options: [
        "Avoid using the person's name altogether",
        "Address the person by name, such as Mr. Smith",
        "Use terms of endearment like honey or darling",
        "Speak only in short, simplified words"
      ],
      correctAnswer: 1
    },
    {
      id: 90409,
      question: "What nonverbal behavior should be avoided when interacting with older patients?",
      options: [
        "Maintaining eye contact throughout the conversation",
        "Facing the patient directly while speaking",
        "Frequently glancing at your watch or looking impatient",
        "Speaking clearly and at a steady pace"
      ],
      correctAnswer: 2
    },
    {
      id: 90410,
      question: "Why is minimizing background noise important when speaking with older adults?",
      options: [
        "It has no real impact on comprehension",
        "It only matters for adults without hearing loss",
        "It reduces the need for eye contact",
        "It frees cognitive resources for processing and understanding speech"
      ],
      correctAnswer: 3
    },
    {
      id: 90411,
      question: "When speaking with an older adult who has a hearing impairment, how should you position yourself?",
      options: [
        "Face the person directly with your lips at the same level as theirs",
        "Stand behind the person to avoid distraction",
        "Speak from a distance to project your voice better",
        "Turn away slightly to reduce direct eye contact"
      ],
      correctAnswer: 0
    },
    {
      id: 90412,
      question: "Why do older adults benefit from having critical information broken into separate, simpler sentences?",
      options: [
        "Older adults cannot understand any long words",
        "Complex sentences with embedded clauses strain working memory",
        "Short sentences are always easier regardless of content",
        "Older adults prefer shorter conversations overall"
      ],
      correctAnswer: 1
    },
    {
      id: 90413,
      question: "What kind of visual aids should be avoided when educating older patients?",
      options: [
        "Aids with large, clearly visible components",
        "Aids that are directly relevant to the discussed topic",
        "Aids containing irrelevant information that may distract",
        "Aids used interactively during conversation"
      ],
      correctAnswer: 2
    },
    {
      id: 90414,
      question: "According to the report, how quickly do some health care providers interrupt patients after they begin speaking?",
      options: [
        "Within 5 seconds",
        "Within 60 seconds",
        "Within 2 minutes",
        "Within 18 seconds"
      ],
      correctAnswer: 3
    },
    {
      id: 90415,
      question: "What type of question is recommended to elicit useful information from older patients?",
      options: [
        "Open-ended questions that allow patients to respond in their own words",
        "A rapid series of yes/no questions",
        "Questions that test the patient's memory of past events",
        "Leading questions that suggest the expected answer"
      ],
      correctAnswer: 0
    },
    {
      id: 90416,
      question: "What should health care providers do to help older patients manage fear about aging and chronic disease?",
      options: [
        "Avoid discussing psychosocial concerns entirely",
        "Express genuine understanding and compassion beyond simple pleasantries",
        "Focus exclusively on biomedical issues",
        "Limit conversation time to reduce patient anxiety"
      ],
      correctAnswer: 1
    },
    {
      id: 90417,
      question: "Why should providers ask about an older adult's living situation and social contacts?",
      options: [
        "To fill time during the appointment",
        "To determine which medications to prescribe",
        "Because older adults are at higher risk for abuse or exploitation",
        "Because it is required for insurance billing"
      ],
      correctAnswer: 2
    },
    {
      id: 90418,
      question: "In the Mrs. Smithberger case, what mistake did the physician initially make?",
      options: [
        "Speaking too loudly to the patient",
        "Failing to explain the hip fracture diagnosis",
        "Refusing to transfer her to another hospital",
        "Addressing the daughter instead of Mrs. Smithberger directly about her care"
      ],
      correctAnswer: 3
    },
    {
      id: 90419,
      question: "What is recommended when a family member or caregiver accompanies an older patient?",
      options: [
        "Maintain direct communication with the patient and avoid third-person references",
        "Direct all questions to the caregiver, bypassing the patient",
        "Ask the caregiver to leave the room immediately",
        "Assume the caregiver's answers are always accurate"
      ],
      correctAnswer: 0
    },
    {
      id: 90420,
      question: "Why should providers ask older patients about their cultural beliefs and alternative medicine practices?",
      options: [
        "To discourage any non-Western practices",
        "Because ignoring cultural context can lead to inaccurate diagnosis and poor adherence",
        "Because all older adults share identical cultural beliefs",
        "To fulfill a legal requirement unrelated to care quality"
      ],
      correctAnswer: 1
    },
    {
      id: 90421,
      question: "What does \"shared decision making\" involve?",
      options: [
        "The provider making all decisions without patient input",
        "Letting the patient decide entirely without any provider recommendations",
        "Providing complete, impartial information and deciding jointly with the patient",
        "Avoiding discussion of treatment options altogether"
      ],
      correctAnswer: 2
    },
    {
      id: 90422,
      question: "How can providers identify older patients who would benefit from more active participation in care decisions?",
      options: [
        "Assume all older patients want the same level of involvement",
        "Only involve patients who arrive with a caregiver",
        "Base involvement solely on the patient's age",
        "Observe whether they engage in discussion, ask questions, or defer quickly to the provider"
      ],
      correctAnswer: 3
    },
    {
      id: 90423,
      question: "What is one way ageist assumptions can emerge in preventive care, per the report?",
      options: [
        "Physicians provide fewer preventive care recommendations, assuming symptoms are just normal aging",
        "Physicians offer excessive preventive screenings to older patients",
        "Physicians always recommend smoking cessation to older adults",
        "Physicians treat older adults exactly the same as younger adults in every respect"
      ],
      correctAnswer: 0
    },
    {
      id: 90424,
      question: "Why is concrete, direct language preferred over abstract language with older patients?",
      options: [
        "It always uses fewer words than abstract language",
        "It requires fewer cognitive resources and reduces incorrect inferences",
        "It is required by law in medical settings",
        "It eliminates the need for follow-up questions"
      ],
      correctAnswer: 1
    },
    {
      id: 90425,
      question: "What is the \"teach-back\" technique?",
      options: [
        "Asking the patient to memorize instructions silently",
        "Repeating information exactly the same way multiple times",
        "Asking the patient to explain the information back in their own words",
        "Testing the patient with a written quiz"
      ],
      correctAnswer: 2
    },
    {
      id: 90426,
      question: "What did Sudore and colleagues find using the \"teach-to-goal\" approach with informed consent forms?",
      options: [
        "Only 28% of participants ever understood the material",
        "The technique was not effective for patients with limited literacy",
        "Comprehension decreased with each additional repetition",
        "Repeated passes eventually achieved comprehension in 98% of participants"
      ],
      correctAnswer: 3
    },
    {
      id: 90427,
      question: "According to socioemotional selectivity theory, what type of messages do older adults respond to more strongly?",
      options: [
        "Messages associated with feelings and connectedness to family",
        "Purely technical and statistical information",
        "Messages emphasizing worst-case scenarios",
        "Messages that avoid any emotional content"
      ],
      correctAnswer: 0
    },
    {
      id: 90428,
      question: "Which practice is recommended to enhance patient satisfaction in a medical office setting?",
      options: [
        "Scheduling older adults for late afternoon appointments only",
        "Scheduling appointments earlier in the day, when things are less hectic",
        "Avoiding greeting patients by name to save time",
        "Minimizing staff introductions to streamline visits"
      ],
      correctAnswer: 1
    },
    {
      id: 90429,
      question: "When should humor and a direct communication style be used with caution?",
      options: [
        "When interacting with any patient under the age of 30",
        "Humor should never be used with any patient",
        "When interacting with non-Western older patients who may prefer indirect, deferential communication",
        "Direct communication is only a concern in emergency settings"
      ],
      correctAnswer: 2
    },
    {
      id: 90430,
      question: "In the Mrs. Baldwin mini case, what communication approach helped Irene engage the resident more successfully?",
      options: [
        "Giving direct commands and repeating them louder",
        "Ignoring Mrs. Baldwin's refusals and proceeding anyway",
        "Speaking in a raised, urgent tone to get her moving quickly",
        "Using open-ended questions and knowledge of Mrs. Baldwin's life history"
      ],
      correctAnswer: 3
    },
    {
      id: 90431,
      question: "Why should speakers avoid speaking slowly to older adults with dementia?",
      options: [
        "Slower speech places extra burden on working memory and can increase misunderstanding",
        "It has no effect on comprehension either way",
        "Faster speech is always easier to understand for people with dementia",
        "Speaking slowly is required to enunciate words properly"
      ],
      correctAnswer: 0
    },
    {
      id: 90432,
      question: "What type of question is best for gathering specific information from a patient with dementia?",
      options: [
        "Open-ended questions about long-past events",
        "Closed-ended choice or yes/no questions",
        "Abstract hypothetical questions",
        "Questions that test episodic memory"
      ],
      correctAnswer: 1
    },
    {
      id: 90433,
      question: "What is a right-branching sentence?",
      options: [
        "A sentence with an embedded clause interrupting the main clause",
        "A sentence that begins with a subordinating conjunction",
        "A sentence where the main clause comes first, followed by a subordinate clause",
        "A sentence using only single-syllable words"
      ],
      correctAnswer: 2
    },
    {
      id: 90434,
      question: "What are two strategies recommended to facilitate comprehension in older adults with dementia when a sentence is misunderstood?",
      options: [
        "Speaking louder and repeating the exact same sentence",
        "Ignoring the confusion and moving to a new topic",
        "Using longer, more complex sentence structures",
        "Verbatim repetition or paraphrasing the sentence"
      ],
      correctAnswer: 3
    },
    {
      id: 90435,
      question: "Vocabulary and general verbal comprehension typically decline significantly as adults age.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90436,
      question: "Cataracts are considered a normal part of the aging process.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90437,
      question: "Elderspeak, or \"baby talk,\" can lead to increased resistance to care among patients with Alzheimer's disease.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90438,
      question: "When a caregiver accompanies an older patient, health care providers should always speak to the caregiver instead of the patient.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90439,
      question: "Both verbatim repetition and paraphrasing can help facilitate comprehension in older adults with dementia.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
   "6. Communicating with Older Adults (Part 2)": [
    {
      id: 90440,
      question: "In the opening scenario, how old is Mr. Howell, the patient with Alzheimer's disease?",
      options: [
        "89 years old",
        "85 years old",
        "92 years old",
        "80 years old"
      ],
      correctAnswer: 0
    },
    {
      id: 90441,
      question: "According to the article, the number of Americans aged 65 and older was predicted to reach 40 million by what year?",
      options: [
        "2005",
        "2010",
        "2015",
        "2020"
      ],
      correctAnswer: 1
    },
    {
      id: 90442,
      question: "By 2020, the number of Americans aged 65 and older was predicted to rise to more than:",
      options: [
        "45 million",
        "50 million",
        "55 million",
        "60 million"
      ],
      correctAnswer: 2
    },
    {
      id: 90443,
      question: "According to the article, roughly how many new chronic diseases are patients likely to acquire for every decade of life after age 40?",
      options: [
        "2 new chronic diseases",
        "3 new chronic diseases",
        "0.5 new chronic diseases",
        "1 new chronic disease"
      ],
      correctAnswer: 3
    },
    {
      id: 90444,
      question: "An 80-year-old person is likely to have at least how many chronic illnesses, per the article?",
      options: [
        "4 chronic illnesses",
        "2 chronic illnesses",
        "6 chronic illnesses",
        "8 chronic illnesses"
      ],
      correctAnswer: 0
    },
    {
      id: 90445,
      question: "Compared with younger patients, how do older patients generally behave during medical visits, according to the article?",
      options: [
        "They ask more detailed questions than younger patients",
        "They ask fewer questions and defer to the physician's authority",
        "They frequently challenge the physician's recommendations",
        "They request second opinions more often than younger patients"
      ],
      correctAnswer: 1
    },
    {
      id: 90446,
      question: "What did the article note about physicians' time spent on psychosocial issues with older patients?",
      options: [
        "Physicians spend equal time on psychosocial issues regardless of age",
        "Physicians spend more time on psychosocial issues with older patients",
        "Doctors spend less time on psychosocial issues with older patients",
        "Psychosocial issues are always addressed thoroughly with older patients"
      ],
      correctAnswer: 2
    },
    {
      id: 90447,
      question: "How should physicians address patients to demonstrate respect, according to the article?",
      options: [
        "Using casual nicknames the patient did not request",
        "Only by their first name in every situation",
        "Using terms like \"sweetie\" or \"honey\" to show warmth",
        "Formally as \"Mr.\" or \"Mrs.\" unless the patient requests otherwise"
      ],
      correctAnswer: 3
    },
    {
      id: 90448,
      question: "What is recommended regarding eye level when communicating with older patients?",
      options: [
        "Sit in a chair and face the patient directly at eye level",
        "Stand above the patient to appear authoritative",
        "Position yourself behind the patient's line of sight",
        "Communicate primarily while looking at the computer screen"
      ],
      correctAnswer: 0
    },
    {
      id: 90449,
      question: "What physical gesture is suggested to convey concern and interest toward older patients?",
      options: [
        "A firm handshake held for an extended time",
        "A gentle touch on the patient's hand, arm, or shoulder",
        "Patting the patient on the head",
        "Avoiding all physical contact entirely"
      ],
      correctAnswer: 1
    },
    {
      id: 90450,
      question: "What communication pace is recommended to help ensure older patients feel heard?",
      options: [
        "A rapid pace to cover more topics in less time",
        "A pace dictated entirely by the accompanying caregiver",
        "An unhurried pace, allowing the patient time to talk without interruption",
        "A pace that minimizes any time spent listening to the patient"
      ],
      correctAnswer: 2
    },
    {
      id: 90451,
      question: "How should physicians generally speak to older patients, per the article?",
      options: [
        "Quickly and quietly, using complex medical terminology",
        "In a whisper, using long compound sentences",
        "Loudly and rapidly, using technical vocabulary",
        "Slowly, clearly, and loudly without shouting, using short simple words"
      ],
      correctAnswer: 3
    },
    {
      id: 90452,
      question: "Because older patients ask fewer questions, what should physicians do more often during the visit?",
      options: [
        "Summarize frequently and invite questions",
        "Assume the patient has no additional concerns",
        "Move quickly to the next topic without pausing",
        "Rely solely on the caregiver to raise concerns"
      ],
      correctAnswer: 0
    },
    {
      id: 90453,
      question: "What should be done before the appointment to help manage older patients' complex health issues?",
      options: [
        "Cancel the appointment if the chart is incomplete",
        "Gather preliminary data before the appointment",
        "Wait until the visit to review any patient history",
        "Ask the caregiver to complete all forms in advance only"
      ],
      correctAnswer: 1
    },
    {
      id: 90454,
      question: "Why should older patients tell their story only once rather than repeating it to a nurse and then the physician?",
      options: [
        "To reduce the length of the medical chart",
        "To satisfy insurance documentation requirements",
        "To minimize patient frustration and fatigue",
        "To prevent the caregiver from hearing the story"
      ],
      correctAnswer: 2
    },
    {
      id: 90455,
      question: "What type of language should physicians avoid using with older patients, according to the article?",
      options: [
        "Simple, short sentences",
        "Written instructions",
        "Visual aids such as charts and pictures",
        "Medical jargon"
      ],
      correctAnswer: 3
    },
    {
      id: 90456,
      question: "What time of day is recommended for scheduling appointments with older patients?",
      options: [
        "Earlier in the day, when they are generally more alert",
        "Late afternoon, after other appointments are finished",
        "Only during lunch hours to reduce wait times",
        "Late evening, when clinics are quieter"
      ],
      correctAnswer: 0
    },
    {
      id: 90457,
      question: "Who first coined the term \"ageism\"?",
      options: [
        "Susan Thompson Hingle",
        "Robert Butler",
        "Sherry Robinson",
        "Debra Roter"
      ],
      correctAnswer: 1
    },
    {
      id: 90458,
      question: "Which of the following is listed as an example of ageism in health care, per the article?",
      options: [
        "Providing more preventive education to older patients",
        "Spending additional time on psychosocial issues with elders",
        "Using condescending language and derogatory names toward elders",
        "Offering extensive treatment for elders' mental health issues"
      ],
      correctAnswer: 2
    },
    {
      id: 90459,
      question: "How can physicians avoid ageism, according to the article?",
      options: [
        "By assuming all older patients share the same needs",
        "By treating every older patient identically regardless of history",
        "By minimizing the time spent learning about the patient's background",
        "By getting to know the older patient as an individual with a unique history"
      ],
      correctAnswer: 3
    },
    {
      id: 90460,
      question: "What percentage of individuals over age 65 have hearing loss that interferes with communication, per the studies cited?",
      options: [
        "16% to 24%",
        "5% to 10%",
        "30% to 40%",
        "50% to 60%"
      ],
      correctAnswer: 0
    },
    {
      id: 90461,
      question: "For adults over age 80, what percentage were found to have hearing loss, according to the article?",
      options: [
        "Less than 20%",
        "More than 60%",
        "About 35%",
        "Exactly 50%"
      ],
      correctAnswer: 1
    },
    {
      id: 90462,
      question: "What is presbycusis?",
      options: [
        "A visual condition affecting color perception",
        "A memory disorder affecting word retrieval",
        "Age-related hearing decline that particularly affects high-frequency sounds",
        "A speech disorder affecting sentence formation"
      ],
      correctAnswer: 2
    },
    {
      id: 90463,
      question: "Why might a patient with presbycusis mishear \"Take the pill in the morning\" as \"Rake the hill in the morning\"?",
      options: [
        "Because the patient is not paying attention to the speaker",
        "Because vowel sounds are lost before consonant sounds",
        "Because the sentence is grammatically too complex to follow",
        "Because consonant sounds affecting word beginnings and endings are lost first"
      ],
      correctAnswer: 3
    },
    {
      id: 90464,
      question: "What visual change makes it difficult for older adults to distinguish colors such as lavender, blue, and green?",
      options: [
        "Yellowing of the eye's lens",
        "Increased pupil diameter",
        "Improved ciliary muscle elasticity",
        "Enhanced retinal sensitivity"
      ],
      correctAnswer: 0
    },
    {
      id: 90465,
      question: "What percentage of adults over age 70 reported their vision as poor, per the article?",
      options: [
        "Less than 5%",
        "More than 15%",
        "Exactly 10%",
        "About 8%"
      ],
      correctAnswer: 1
    },
    {
      id: 90466,
      question: "What percentage of adults over age 80 reported their vision as impaired?",
      options: [
        "10%",
        "20%",
        "30%",
        "45%"
      ],
      correctAnswer: 2
    },
    {
      id: 90467,
      question: "When speaking with a patient who has hearing loss, what should physicians avoid doing?",
      options: [
        "Facing the patient directly",
        "Speaking in a normal tone",
        "Minimizing background noise",
        "Shouting, since it distorts high-frequency tones"
      ],
      correctAnswer: 3
    },
    {
      id: 90468,
      question: "Instead of asking \"Do you understand?\" what should physicians do to check comprehension in hearing-impaired patients?",
      options: [
        "Ask the patient to repeat the instructions",
        "Assume understanding if the patient nods",
        "Repeat the same question louder",
        "Move on without further verification"
      ],
      correctAnswer: 0
    },
    {
      id: 90469,
      question: "Why are early appointments generally better for patients with hearing loss, per the article?",
      options: [
        "Because clinics are always fully staffed in the morning",
        "Because hearing tends to worsen later in the day",
        "Because patients prefer shorter wait times in the morning",
        "Because physicians are less rushed in the morning"
      ],
      correctAnswer: 1
    },
    {
      id: 90470,
      question: "What print specification is recommended for written materials given to visually impaired patients?",
      options: [
        "At least 8-point type on white paper",
        "At least 10-point type on glossy paper",
        "At least 14-point type on buff-colored paper",
        "At least 12-point type on dark paper"
      ],
      correctAnswer: 2
    },
    {
      id: 90471,
      question: "Approximately how many people in the United States had some form of dementia as of 2008, according to the article?",
      options: [
        "2.1 million",
        "3.5 million",
        "8 million",
        "5.2 million"
      ],
      correctAnswer: 3
    },
    {
      id: 90472,
      question: "In mild stages of dementia, what type of communication problem is commonly experienced first?",
      options: [
        "Subtle word-finding problems",
        "Complete loss of speech",
        "Inability to recognize any family members",
        "Total loss of long-term memory"
      ],
      correctAnswer: 0
    },
    {
      id: 90473,
      question: "What happens to communication as dementia progresses to more severe stages, per the article?",
      options: [
        "Patients speak in increasingly complex sentences",
        "Patients may use unintelligible jargon or become mute",
        "Patients regain earlier language abilities",
        "Patients begin to ask more detailed questions"
      ],
      correctAnswer: 1
    },
    {
      id: 90474,
      question: "According to the article, what do patients with dementia respond to more than the actual content of what is said?",
      options: [
        "The volume of the speaker's voice alone",
        "The specific vocabulary used by the speaker",
        "How someone talks to them, such as tone and manner",
        "The length of the sentences being spoken"
      ],
      correctAnswer: 2
    },
    {
      id: 90475,
      question: "Why is reminiscing considered an effective communication technique with dementia patients?",
      options: [
        "It tests the patient's short-term memory abilities",
        "It distracts the patient from the purpose of the visit",
        "It requires the patient to recall very recent events",
        "Long-term memory is often retained, and it helps reduce stress"
      ],
      correctAnswer: 3
    },
    {
      id: 90476,
      question: "What type of questions often work best with patients who have dementia?",
      options: [
        "Closed-ended \"yes\" or \"no\" questions",
        "Long, open-ended narrative questions",
        "Questions requiring detailed recent recall",
        "Multiple-part questions asked all at once"
      ],
      correctAnswer: 0
    },
    {
      id: 90477,
      question: "How long should a physician wait before repeating a question to a patient with dementia, per the article?",
      options: [
        "5 to 10 seconds",
        "15 to 20 seconds",
        "30 to 45 seconds",
        "1 to 2 minutes"
      ],
      correctAnswer: 1
    },
    {
      id: 90478,
      question: "When performing a physical exam on a patient with dementia, what approach is recommended?",
      options: [
        "Give several instructions together to save time",
        "Perform the exam without explaining any steps",
        "Give one instruction at a time and ask permission before each step",
        "Skip verbal instructions and rely on gestures alone"
      ],
      correctAnswer: 2
    },
    {
      id: 90479,
      question: "In what proportion of geriatric clinic visits is a family member or caregiver present, per the article?",
      options: [
        "Less than one tenth",
        "About one fifth",
        "Nearly all visits",
        "At least one third"
      ],
      correctAnswer: 3
    },
    {
      id: 90480,
      question: "At the first visit with a new patient and caregiver, what is recommended for protecting patient privacy?",
      options: [
        "See the patient alone first, then ask permission to speak with the caregiver",
        "Always speak to the caregiver before greeting the patient",
        "Require the caregiver to leave before the patient arrives",
        "Discuss the patient's history only with the caregiver"
      ],
      correctAnswer: 0
    },
    {
      id: 90481,
      question: "How should chairs be arranged when a caregiver is present during a visit, according to the article?",
      options: [
        "In a straight row facing the door",
        "In a triangle, so all three people face each other",
        "With the caregiver seated behind the patient",
        "With the physician standing throughout the visit"
      ],
      correctAnswer: 1
    },
    {
      id: 90482,
      question: "When a caregiver is present, who should the physician direct questions to first?",
      options: [
        "The caregiver, before involving the patient",
        "Neither party, to avoid confusion",
        "The patient, before asking for input from the caregiver",
        "Whoever answers first, regardless of who it is"
      ],
      correctAnswer: 2
    },
    {
      id: 90483,
      question: "According to the article's conclusion, effective physician-older patient communication makes patients more likely to do what regarding symptoms?",
      options: [
        "Withhold symptoms until a follow-up visit",
        "Report only the symptoms the caregiver mentions",
        "Minimize the number of concerns they raise",
        "Share their symptoms and concerns, enabling a more accurate diagnosis"
      ],
      correctAnswer: 3
    },
    {
      id: 90484,
      question: "Older patients generally ask more questions and challenge physician authority more than younger patients.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90485,
      question: "The term \"ageism\" was first coined by Robert Butler, the first director of the National Institute on Aging.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90486,
      question: "Shouting is an effective way to help hearing-impaired older patients understand instructions.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90487,
      question: "Reminiscing with dementia patients can help reduce stress because long-term memory is often retained.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90488,
      question: "A caregiver's presence should always exclude the older patient from decision-making during the visit.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
   "7. Mobile Practices (Part 1)": [
    {
      id: 90489,
      question: "Which of the following best describes why oral health matters for older adults?",
      options: [
        "Oral disease is linked to systemic conditions like diabetes and pneumonia",
        "Oral disease has no connection to overall health",
        "Oral health only affects appearance, not systemic health",
        "Oral health issues are rare among older adults"
      ],
      correctAnswer: 0
    },
    {
      id: 90490,
      question: "Which age-related physiological change most directly increases the risk of dry mouth?",
      options: [
        "Increase in oral mucosa thickness",
        "Decline in salivary gland function",
        "Increase in bone density",
        "Improvement in cognitive function"
      ],
      correctAnswer: 1
    },
    {
      id: 90491,
      question: "What oral health risk results from gingival recession in older adults?",
      options: [
        "Reduced risk of dental decay",
        "Thicker, more resistant oral mucosa",
        "Exposed root surfaces that are prone to decay",
        "Increased saliva production"
      ],
      correctAnswer: 2
    },
    {
      id: 90492,
      question: "What is a common cause of xerostomia in older adult patients?",
      options: [
        "Excessive fluoride use",
        "Overuse of mouthwash",
        "Frequent brushing habits",
        "Medication side effects"
      ],
      correctAnswer: 3
    },
    {
      id: 90493,
      question: "Which condition is a common opportunistic fungal infection seen in denture wearers?",
      options: [
        "Oral candidiasis",
        "Root caries",
        "Periodontal disease",
        "Edentulism"
      ],
      correctAnswer: 0
    },
    {
      id: 90494,
      question: "Which of the following is a key responsibility of dental hygienists working with aging populations?",
      options: [
        "Performing surgical extractions independently",
        "Providing preventive care and patient education",
        "Prescribing systemic medications",
        "Managing hospital admissions"
      ],
      correctAnswer: 1
    },
    {
      id: 90495,
      question: "What is a defining characteristic of long-term care (LTC) facilities in Canada?",
      options: [
        "They provide only short-term rehabilitation",
        "They serve only children with disabilities",
        "They provide 24-hour residential care for aging populations",
        "They focus exclusively on dental treatment"
      ],
      correctAnswer: 2
    },
    {
      id: 90496,
      question: "Which of the following is identified as a common barrier to oral care in LTC facilities?",
      options: [
        "Excessive availability of dental professionals on-site",
        "Overfunding of dental training programs",
        "Too many oral health regulations",
        "Staffing shortages limiting time for oral hygiene care"
      ],
      correctAnswer: 3
    },
    {
      id: 90497,
      question: "What is a key responsibility of caregivers regarding oral health in LTC settings?",
      options: [
        "Assisting with daily oral hygiene and monitoring for disease signs",
        "Performing periodontal surgery",
        "Prescribing antibiotics for infections",
        "Diagnosing systemic diseases independently"
      ],
      correctAnswer: 0
    },
    {
      id: 90498,
      question: "According to Marilynne Fine's research, what is essential for meeting the needs of LTC residents?",
      options: [
        "Maintaining only traditional dental office models",
        "Mobile and alternative dental hygiene practices",
        "Eliminating dental hygienist involvement in LTC",
        "Reducing caregiver training requirements"
      ],
      correctAnswer: 1
    },
    {
      id: 90499,
      question: "How is mobile dental hygiene best defined?",
      options: [
        "Dental hygiene services provided only in hospitals",
        "A method of billing for dental insurance",
        "Dental hygiene services provided at locations other than a traditional office",
        "A type of dental equipment used in clinics"
      ],
      correctAnswer: 2
    },
    {
      id: 90500,
      question: "Which of the following is a benefit of mobile dental hygiene services?",
      options: [
        "Reduced patient compliance",
        "Limited equipment availability",
        "More complex licensing requirements",
        "Increased access for patients with mobility issues"
      ],
      correctAnswer: 3
    },
    {
      id: 90501,
      question: "What is a common challenge faced in mobile dental hygiene practice?",
      options: [
        "Limited access to equipment and supplies",
        "Unlimited access to full clinical equipment",
        "Simplified licensing and insurance processes",
        "Excessive continuity of patient care"
      ],
      correctAnswer: 0
    },
    {
      id: 90502,
      question: "What determines the scope of practice for independent dental hygienists?",
      options: [
        "Federal healthcare policy alone",
        "Provincial or territorial regulatory bodies such as the CDHO",
        "Individual patient preference",
        "International dental associations only"
      ],
      correctAnswer: 1
    },
    {
      id: 90503,
      question: "According to CDHA, what is critical for the success of mobile dental hygiene?",
      options: [
        "Avoiding collaboration with other providers",
        "Strict adherence to traditional office hours",
        "Flexibility, innovation, and collaboration",
        "Reducing investment in portable equipment"
      ],
      correctAnswer: 2
    },
    {
      id: 90504,
      question: "Which organization defines the scope of practice for dental hygienists in Ontario?",
      options: [
        "Canadian Dental Association",
        "World Health Organization",
        "Ontario Ministry of Transportation",
        "College of Dental Hygienists of Ontario (CDHO)"
      ],
      correctAnswer: 3
    },
    {
      id: 90505,
      question: "Why are temporary restorations used in dental treatment?",
      options: [
        "To protect tooth function until a permanent restoration is placed",
        "To permanently replace missing teeth",
        "To whiten teeth before a permanent crown",
        "To eliminate the need for future dental visits"
      ],
      correctAnswer: 0
    },
    {
      id: 90506,
      question: "Which material is commonly used for temporary restorations?",
      options: [
        "Stainless steel wire",
        "Zinc oxide-eugenol",
        "Orthodontic elastic bands",
        "Surgical gauze"
      ],
      correctAnswer: 1
    },
    {
      id: 90507,
      question: "What must dental hygienists do regarding temporary restorations under CDHO guidelines?",
      options: [
        "Place them without any documentation",
        "Avoid using approved materials",
        "Monitor them for integrity and document the procedure",
        "Perform them without regard to scope of practice"
      ],
      correctAnswer: 2
    },
    {
      id: 90508,
      question: "When placing a temporary restoration, what should hygienists communicate to patients?",
      options: [
        "That the restoration is permanent and needs no follow-up",
        "That no maintenance is required",
        "That the restoration cannot fail",
        "The temporary nature of the restoration and need for follow-up"
      ],
      correctAnswer: 3
    },
    {
      id: 90509,
      question: "What is a potential challenge when placing a temporary restoration?",
      options: [
        "Difficulty achieving a proper fit due to cavity shape and size",
        "Excessive strength of the temporary material",
        "Too much time available for the procedure",
        "Overabundance of appropriate materials"
      ],
      correctAnswer: 0
    },
    {
      id: 90510,
      question: "What should be assessed before placing a temporary restoration?",
      options: [
        "The patient's favorite toothpaste brand",
        "The tooth and surrounding tissues for infection or damage",
        "The color of the patient's dental chart",
        "The patient's insurance provider only"
      ],
      correctAnswer: 1
    },
    {
      id: 90511,
      question: "Which of the following is an example of a non-traditional job for a dental hygienist?",
      options: [
        "Working exclusively in a private dental office",
        "Performing only administrative billing tasks",
        "Mobile dental hygiene and public health outreach",
        "Working solely as a dental assistant"
      ],
      correctAnswer: 2
    },
    {
      id: 90512,
      question: "Which of the following represents an expansion of dental hygienists' scope of practice?",
      options: [
        "Restricting hygienists to cleaning services only",
        "Removing hygienists from preventive care roles",
        "Eliminating fluoride treatment duties",
        "Independent practice without a supervising dentist"
      ],
      correctAnswer: 3
    },
    {
      id: 90513,
      question: "What is a focus of community-based dental hygiene roles?",
      options: [
        "Promoting oral health and preventing disease at the population level",
        "Providing only cosmetic dental procedures",
        "Limiting services to private paying patients",
        "Avoiding collaboration with schools or communities"
      ],
      correctAnswer: 0
    },
    {
      id: 90514,
      question: "According to CDHA, which of the following is a recognized practice setting for dental hygienists?",
      options: [
        "Only hospital surgical wards",
        "Long-term care facilities and community health centers",
        "Exclusively pharmaceutical companies",
        "Only government tax offices"
      ],
      correctAnswer: 1
    },
    {
      id: 90515,
      question: "What is a challenge dental hygienists face when working in long-term care facilities?",
      options: [
        "Excessive access to dental care resources",
        "Too much specialized geriatric training",
        "Communication barriers with patients and care providers",
        "Overabundance of on-site equipment"
      ],
      correctAnswer: 2
    },
    {
      id: 90516,
      question: "In what area can dental hygienists contribute to research?",
      options: [
        "Automotive engineering standards",
        "Agricultural policy development",
        "Financial market analysis",
        "Oral health disparities and geriatric oral health"
      ],
      correctAnswer: 3
    },
    {
      id: 90517,
      question: "What is a key component of developing effective oral health programs for seniors?",
      options: [
        "Comprehensive assessment of oral health needs",
        "Ignoring collaboration with healthcare providers",
        "Avoiding preventive care strategies",
        "Excluding caregiver education"
      ],
      correctAnswer: 0
    },
    {
      id: 90518,
      question: "What is a key area for policy improvement in LTC oral health advocacy?",
      options: [
        "Reducing insurance coverage for dental services",
        "Standardizing care procedures for oral health in LTC facilities",
        "Eliminating routine oral health assessments",
        "Decreasing funding for oral health initiatives"
      ],
      correctAnswer: 1
    },
    {
      id: 90519,
      question: "Which emerging trend is transforming geriatric oral care?",
      options: [
        "Elimination of all technology in dental practice",
        "Discontinuation of mobile dental clinics",
        "Increased use of tele-dentistry and AI for early detection",
        "Removal of fluoride treatments from practice"
      ],
      correctAnswer: 2
    },
    {
      id: 90520,
      question: "What has been a documented impact of successful mobile and LTC dental hygiene programs?",
      options: [
        "Decreased access to care for underserved populations",
        "Reduced quality of life for elderly residents",
        "Increased barriers to interprofessional collaboration",
        "Improved oral health outcomes for residents"
      ],
      correctAnswer: 3
    },
    {
      id: 90521,
      question: "Aspiration pneumonia risk is increased due to poor oral hygiene in LTC residents.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90522,
      question: "Dental hygienists are permitted to perform surgical extractions as part of their standard scope of practice.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90523,
      question: "Mobile dental hygiene services can be provided in schools, community centers, and private homes.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90524,
      question: "Temporary restorations are intended to be permanent and require no follow-up visits.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
   "7. Mobile Practices (Part 2)": [
    {
      id: 90525,
      question: "What is true regarding a dental hygienist's ability to place a temporary restoration?",
      options: [
        "All registrants may perform temporary restorative procedures as part of their scope of practice, in any setting",
        "Only registrants with a restorative specialty certificate may perform temporary restorations",
        "Temporary restorations may only be performed by dentists, never hygienists",
        "Temporary restorations are outside the scope of practice for all hygienists"
      ],
      correctAnswer: 0
    },
    {
      id: 90526,
      question: "What does the CDHO guideline say determines whether a temporary restoration should be performed?",
      options: [
        "It depends solely on the client's insurance coverage",
        "It depends on the competence of the dental hygienist and the needs of the client",
        "It depends only on the availability of a dental assistant",
        "It depends exclusively on the time of day the appointment occurs"
      ],
      correctAnswer: 1
    },
    {
      id: 90527,
      question: "What must a dental hygienist always do when placing a temporary restoration?",
      options: [
        "Avoid mentioning the temporary nature of the restoration",
        "Delay any referral until the client requests one",
        "Inform the client that the restoration is temporary and refer them to a dentist",
        "Wait for the client's next routine cleaning to explain the restoration"
      ],
      correctAnswer: 2
    },
    {
      id: 90528,
      question: "What are the primary reasons a dental hygienist would place a temporary restoration?",
      options: [
        "To permanently resolve the client's dental issue without a dentist",
        "To improve the appearance of the tooth for cosmetic purposes",
        "To replace the need for any future dental examination",
        "To free the client from pain and reduce further damage until they can see a dentist"
      ],
      correctAnswer: 3
    },
    {
      id: 90529,
      question: "Which materials are typically used for temporary restorations according to the guideline?",
      options: [
        "Zinc-oxide eugenol, glass ionomer, or other medicated/non-medicated temporary cements",
        "Amalgam, gold alloy, or porcelain fused to metal",
        "Composite resin veneers and orthodontic brackets",
        "Surgical sutures and periodontal dressing material"
      ],
      correctAnswer: 0
    },
    {
      id: 90530,
      question: "Which of the following is a required condition before placing a temporary restoration as a preventive measure?",
      options: [
        "The client must already be scheduled with a dentist that same day",
        "The pulp must not be exposed",
        "The tooth must be a permanent molar only",
        "The client must have no other dental restorations present"
      ],
      correctAnswer: 1
    },
    {
      id: 90531,
      question: "According to the guideline, what must be true regarding client consent before placing a temporary restoration?",
      options: [
        "Consent is not required if the client is in pain",
        "Consent may be given verbally by a family member only",
        "The client consents to the treatment and it is in the client's best interest to proceed",
        "Consent is only needed for permanent restorations, not temporary ones"
      ],
      correctAnswer: 2
    },
    {
      id: 90532,
      question: "Which condition must be met regarding contraindications before placing a temporary restoration?",
      options: [
        "The client must have a documented allergy to the material",
        "The dentist must be physically present in the room",
        "The client must have previously used the same material",
        "There must be no medical contraindications to the restorative material"
      ],
      correctAnswer: 3
    },
    {
      id: 90533,
      question: "What must be recorded in the client record after a temporary restoration is placed?",
      options: [
        "The tooth restored, the material used, and the notification that the restoration is temporary",
        "Only the client's next appointment date",
        "Only the cost billed for the procedure",
        "Only the name of the dental hygienist who performed the work"
      ],
      correctAnswer: 0
    },
    {
      id: 90534,
      question: "Can a dental hygienist place a temporary restoration if a dentist is present in the office?",
      options: [
        "No, a dentist must always place the restoration personally",
        "Yes, if the dentist and hygienist agree it is in the client's best interest",
        "No, the hygienist must wait until the dentist leaves the office",
        "Yes, but only with written consent from the College"
      ],
      correctAnswer: 1
    },
    {
      id: 90535,
      question: "What should a dental hygienist do if a crown comes off while scaling and a dentist is unavailable?",
      options: [
        "Discard the crown and schedule a new permanent restoration",
        "Leave the crown off until the next scheduled dental visit",
        "Re-cement the crown with a temporary adhesive and advise the client to see a dentist soon",
        "Refer the client to an emergency room for crown replacement"
      ],
      correctAnswer: 2
    },
    {
      id: 90536,
      question: "When should a temporary restoration NOT be performed?",
      options: [
        "When the client has expressed mild discomfort",
        "When the restoration material is glass ionomer cement",
        "When the client has a scheduled dentist appointment",
        "When professional judgment indicates removal of tooth structure is required for proper placement"
      ],
      correctAnswer: 3
    },
    {
      id: 90537,
      question: "What is Interim Stabilization Therapy (IST)?",
      options: [
        "A temporary restoration procedure used to relieve pain and prevent further tooth damage until a dentist can treat it",
        "A permanent restorative technique replacing traditional crowns",
        "A surgical procedure for removing impacted teeth",
        "An orthodontic treatment for aligning misaligned teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 90538,
      question: "What material does IST use, and what property does it provide?",
      options: [
        "Amalgam, which hardens instantly without setting time",
        "Glass ionomer cement, which releases fluoride to help remineralize the lesion",
        "Composite resin, which matches natural tooth color exactly",
        "Zinc phosphate cement, which requires no tooth preparation"
      ],
      correctAnswer: 1
    },
    {
      id: 90539,
      question: "What is the correct preparation sequence for the IST procedure?",
      options: [
        "Apply anaesthetic, drill the tooth, then place a permanent crown",
        "Take an X-ray, extract the tooth, then schedule a follow-up",
        "Remove soft debris from the lesion, apply a conditioner, then place the glass ionomer material",
        "Polish the tooth surface, apply fluoride varnish, then seal with composite"
      ],
      correctAnswer: 2
    },
    {
      id: 90540,
      question: "How does IST differ from other temporary restoration procedures performed by Ontario dental hygienists?",
      options: [
        "It requires a separate license not held by regular hygienists",
        "It can only be performed by dentists, not hygienists",
        "It uses a completely different set of clinical guidelines",
        "It is the name used for the Health Canada Ontario region First Nations Inuit Health Branch COHI program and strictly uses glass ionomer cement"
      ],
      correctAnswer: 3
    },
    {
      id: 90541,
      question: "A dental hygienist must always inform the client that a restoration is temporary and refer them to a dentist.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90542,
      question: "According to the guideline, Interim Stabilization Therapy (IST) requires local anaesthetic before treatment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
   "7. Mobile Practices (Part 3)": [
    {
      id: 90543,
      question: "According to the module's learning objectives, which of the following is NOT one of the three stated goals?",
      options: [
        "Explore the importance of interprofessional collaboration",
        "Develop strategies to address common operational challenges",
        "Master advanced periodontal surgical techniques",
        "Learn to navigate common growth transitions"
      ],
      correctAnswer: 2
    },
    {
      id: 90544,
      question: "Based on the 2017 CDHA Job Market & Employment Survey, which practice setting was reported most frequently by respondents?",
      options: [
        "Store-front or fixed location practice",
        "Mobile dental hygiene practice",
        "Residential care or long-term care facility",
        "Operation conducted out of the home"
      ],
      correctAnswer: 0
    },
    {
      id: 90545,
      question: "In the National Interprofessional Competency Framework, which element sits at the center, connected to all other competency domains?",
      options: [
        "Client-centred care domain",
        "Team functioning domain",
        "Role clarification domain",
        "Interprofessional collaboration"
      ],
      correctAnswer: 3
    },
    {
      id: 90546,
      question: "Which of the following is listed as a tip for effective interprofessional communication?",
      options: [
        "Avoid discussing treatment plans with team",
        "Develop trusting relationships with the team",
        "Limit the use of technology with staff",
        "Withhold information to avoid conflict"
      ],
      correctAnswer: 1
    },
    {
      id: 90547,
      question: "Why is role clarification important for facility staff working with an independent dental hygienist?",
      options: [
        "It helps staff support daily oral care and reduces conflict",
        "It removes the need for dental hygiene visits entirely",
        "It transfers hygiene duties fully to nursing staff",
        "It eliminates all oral health education needs"
      ],
      correctAnswer: 0
    },
    {
      id: 90548,
      question: "What is one benefit of facilitating in-service training for care facility staff?",
      options: [
        "It reduces need for continuing education for hygienists",
        "It removes staff responsibility for daily oral care",
        "It empowers care providers and builds closer relationships",
        "It eliminates oral assessments at facility admission"
      ],
      correctAnswer: 2
    },
    {
      id: 90549,
      question: "According to the module, what challenge do other care team members often face regarding oral assessments at admission?",
      options: [
        "Excessive time allotted for oral assessments",
        "Uncertainty when using oral assessment tools",
        "Overqualification for the assessment task at hand",
        "Lack of interest in resident care overall"
      ],
      correctAnswer: 1
    },
    {
      id: 90550,
      question: "What is a common source of conflict for independent dental hygienists working in long-term care facilities?",
      options: [
        "Having too much administrative staff support",
        "Receiving an excessive number of referrals",
        "Having unlimited access to facility resources",
        "Being viewed as outsiders by facility staff"
      ],
      correctAnswer: 3
    },
    {
      id: 90551,
      question: "What is the purpose of identifying an \"oral health champion\" within a care facility?",
      options: [
        "To raise awareness and help integrate oral health into the team",
        "To replace the dental hygienist's clinical duties completely",
        "To manage the facility's financial recordkeeping tasks",
        "To handle only emergency dental situations onsite"
      ],
      correctAnswer: 0
    },
    {
      id: 90552,
      question: "Which activity best demonstrates collaborative leadership according to the module?",
      options: [
        "Working exclusively within the treatment room",
        "Avoiding facility administrative discussions altogether",
        "Participating in steering committees and planning meetings",
        "Declining invitations to operational planning days"
      ],
      correctAnswer: 2
    },
    {
      id: 90553,
      question: "What is one outcome of successfully harnessing interprofessional competencies in a long-term care setting?",
      options: [
        "Complete removal of hygienists from care teams",
        "Inclusion of oral health in care planning meetings",
        "Elimination of collaborative decision making processes",
        "Reduced opportunities for business growth overall"
      ],
      correctAnswer: 1
    },
    {
      id: 90554,
      question: "Which of the following is a potential solution for reprocessing instruments when no equipment is available on site?",
      options: [
        "Reprocessing instruments in the client's home directly",
        "Skipping instrument reprocessing steps altogether",
        "Requiring clients to purchase their own instruments",
        "Using a contractual agreement with a local office"
      ],
      correctAnswer: 3
    },
    {
      id: 90555,
      question: "What is required as part of setting up pre-authorised debits (PADs) for payment collection?",
      options: [
        "Authorisation, notice of withdrawal, and scheduled payment",
        "A signed franchise agreement with the facility",
        "An in-person cash transaction for each visit",
        "Approval from the provincial dental regulatory board"
      ],
      correctAnswer: 0
    },
    {
      id: 90556,
      question: "What is a key benefit of creating a procedures manual for an independent practice?",
      options: [
        "It eliminates the need for a clinical coordinator",
        "It replaces the need for a bookkeeper role",
        "It calibrates providers and eases new staff onboarding",
        "It removes the requirement for consent forms"
      ],
      correctAnswer: 2
    },
    {
      id: 90557,
      question: "Which task is part of the role of a Clinical Coordinator?",
      options: [
        "Performing instrument reprocessing tasks on site",
        "Booking appointments and managing provider schedules",
        "Diagnosing oral health conditions directly",
        "Delivering direct clinical dental hygiene care"
      ],
      correctAnswer: 1
    },
    {
      id: 90558,
      question: "What is a primary responsibility of a bookkeeper in an independent dental hygiene practice?",
      options: [
        "Scheduling client appointments directly with providers",
        "Providing oral health education to caregivers",
        "Conducting oral assessments at facility admission",
        "Managing timely payments through invoices and PADs"
      ],
      correctAnswer: 3
    },
    {
      id: 90559,
      question: "What method is suggested to help identify a suitable associate dental hygienist candidate for long-term care work?",
      options: [
        "Shadowing or conducting a working job interview",
        "Reviewing only academic transcripts submitted",
        "Administering a standardized written exam only",
        "Randomly selecting from all applicants"
      ],
      correctAnswer: 0
    },
    {
      id: 90560,
      question: "Why might denturists be a good fit for adding to a mobile or long-term care dental hygiene practice?",
      options: [
        "They require the same equipment as dentists",
        "They specialize only in pediatric restorative work",
        "They require less equipment and suit older clientele",
        "They cannot work in limited infrastructure settings"
      ],
      correctAnswer: 2
    },
    {
      id: 90561,
      question: "Which of the following is one of the six factors to consider when evaluating whether a mobile practice has franchise potential?",
      options: [
        "Whether the practice has a mobile van",
        "Whether the business model is easy to replicate",
        "Whether the hygienist holds a second license",
        "Whether the practice avoids all competition"
      ],
      correctAnswer: 1
    },
    {
      id: 90562,
      question: "According to the CDHA Member Resources section, what role can dental hygienists play as \"knowledge brokers\"?",
      options: [
        "Managing facility financial audits and reports",
        "Supervising the dental school curriculum design",
        "Regulating provincial dental licensing boards directly",
        "Providing health promotion and education to caregivers"
      ],
      correctAnswer: 3
    },
    {
      id: 90563,
      question: "True or False: The Canadian Interprofessional Health Collaborative (CIHC) is presented as the source of the National Interprofessional Competency Framework.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90564,
      question: "True or False: Store-front/fixed location was reported as the least common independent practice setting in the 2017 survey.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
   "7. Mobile Practices (Part 4)": [
    {
      id: 90565,
      question: "According to the module, what is the primary goal of independent dental hygiene practice?",
      options: [
        "To increase the public's access to dental hygiene care",
        "To have hygienists work in isolation from dentists",
        "To replace traditional dental offices completely",
        "To eliminate all forms of dental regulation"
      ],
      correctAnswer: 0
    },
    {
      id: 90566,
      question: "What does \"unsupervised\" or \"autonomous\" practice mean for dental hygienists?",
      options: [
        "Working only in isolated freestanding clinics",
        "Making treatment decisions without a dentist's supervision",
        "Being exempt from all provincial regulations",
        "Providing care only within institutions"
      ],
      correctAnswer: 1
    },
    {
      id: 90567,
      question: "How does the module define \"self-regulation\" for dental hygienists?",
      options: [
        "Setting your own working hours freely",
        "Choosing your scope of practice without limits",
        "Being accountable to the public for your actions",
        "Avoiding oversight from regulatory colleges"
      ],
      correctAnswer: 2
    },
    {
      id: 90568,
      question: "The \"Clinical Dental Hygiene - Employee\" setting is best suited for hygienists who prefer what?",
      options: [
        "Full control over business and administrative decisions",
        "Frequent travel and commission-based pay",
        "Complete independence from any dental practice",
        "Set hours and a constant salary and workplace"
      ],
      correctAnswer: 3
    },
    {
      id: 90569,
      question: "According to the module, who bears the financial risk of the business when a dental hygienist works as an employee?",
      options: [
        "The employer bears the financial risk, not the hygienist",
        "The hygienist alone bears all financial risk",
        "Both parties equally share the financial risk",
        "The regulatory college assumes the financial risk"
      ],
      correctAnswer: 0
    },
    {
      id: 90570,
      question: "What is one upside for self-employed contract dental hygienists compared to employees?",
      options: [
        "Guaranteed statutory holiday and vacation pay",
        "Greater income tax deductions for business expenses",
        "Employer contributions to CPP and EI",
        "Complete elimination of self-employment risk"
      ],
      correctAnswer: 1
    },
    {
      id: 90571,
      question: "According to the module, which regulatory example is mentioned as a possible challenge for autonomous self-employed practice?",
      options: [
        "Mandatory dentist co-ownership required in Alberta",
        "A province-wide ban on mobile clinics nationwide",
        "The 365-day rule noted in British Columbia",
        "Federal licensing exams required for hygienists"
      ],
      correctAnswer: 2
    },
    {
      id: 90572,
      question: "Which of the following activities is described as part of a Public Health dental hygiene job?",
      options: [
        "Managing a hospital's oral health program",
        "Writing grant proposals for clinical research",
        "Selling dental products at trade shows",
        "Conducting oral health assessments and fluoride programs"
      ],
      correctAnswer: 3
    },
    {
      id: 90573,
      question: "What is listed as a possible downside of working in Public Health?",
      options: [
        "Somewhat lower pay than clinical practices",
        "Lack of vertical movement opportunities",
        "Excessive administrative paperwork demands",
        "No opportunity for personal growth at all"
      ],
      correctAnswer: 0
    },
    {
      id: 90574,
      question: "What does the Long-Term Care alternative practice setting primarily involve?",
      options: [
        "Working exclusively within a pediatric hospital ward",
        "Mobile, self-employed care in extended care facilities",
        "Writing textbooks for dental hygiene students",
        "Managing an insurance company's claims division"
      ],
      correctAnswer: 1
    },
    {
      id: 90575,
      question: "What is a possible downside of working in Long-Term Care, according to the module?",
      options: [
        "Low salary compared to other settings",
        "Lack of any personal gratification",
        "Morale and stress from non-compliant patients",
        "No flexibility in scheduling work hours"
      ],
      correctAnswer: 2
    },
    {
      id: 90576,
      question: "What is an upside of working as a dental hygienist within a hospital setting?",
      options: [
        "Complete freedom from red tape",
        "Guaranteed low-stress work environment",
        "No need for varied tasks or challenges",
        "More opportunity for vertical promotion than in a clinic"
      ],
      correctAnswer: 3
    },
    {
      id: 90577,
      question: "In the National Defence/Canadian Forces setting, how is the dental hygienist's salary calculated?",
      options: [
        "Based on quality of care, not production",
        "Based strictly on number of patients seen",
        "Based on private practice billing rates",
        "Based on commission from product sales"
      ],
      correctAnswer: 0
    },
    {
      id: 90578,
      question: "What is generally required to work in the Education alternative practice setting?",
      options: [
        "No formal education beyond a diploma",
        "At least a bachelor's degree for most teaching roles",
        "A law degree focused on health policy",
        "Certification in web design and software"
      ],
      correctAnswer: 1
    },
    {
      id: 90579,
      question: "What level of education is generally required for a career in dental hygiene research?",
      options: [
        "A high school diploma only is required",
        "A trade certification in laboratory work",
        "A BSc or MSc, or a more advanced degree",
        "No formal education is necessary at all"
      ],
      correctAnswer: 2
    },
    {
      id: 90580,
      question: "How is income typically earned in the Sales alternative practice setting?",
      options: [
        "Through a fixed government salary",
        "Through hourly public health wages",
        "Through hospital-based promotion bonuses",
        "Through commission and bonus structures"
      ],
      correctAnswer: 3
    },
    {
      id: 90581,
      question: "What is a possible downside of working in Publishing, according to the module?",
      options: [
        "No interaction with clients at all",
        "Extremely low salary compared to sales",
        "Frequent relocation and deployment demands",
        "Excessive stress from patient non-compliance"
      ],
      correctAnswer: 0
    },
    {
      id: 90582,
      question: "What is described as an upside of working in the Dental Insurance setting?",
      options: [
        "Unlimited vacation and travel opportunities",
        "Excellent benefit packages and standard work hours",
        "Complete autonomy over treatment decisions",
        "High commission-based earning potential"
      ],
      correctAnswer: 1
    },
    {
      id: 90583,
      question: "Which job role is associated with the Administration alternative practice setting?",
      options: [
        "Product tester in a dental laboratory",
        "Grant proposal writer for research studies",
        "Office manager or program coordinator",
        "Lobbyist for government policy change"
      ],
      correctAnswer: 2
    },
    {
      id: 90584,
      question: "The Consulting alternative practice setting is best suited for people interested in what?",
      options: [
        "Working exclusively in a laboratory setting",
        "Traveling internationally for volunteer work",
        "Writing textbooks for dental hygiene students",
        "Pursuing an MBA and the business of dental hygiene"
      ],
      correctAnswer: 3
    },
    {
      id: 90585,
      question: "What is a possible downside of working in Computer Software or Web Design, per the module?",
      options: [
        "No opportunity to use practical dental hygiene skills",
        "Extremely low and unstable salary levels",
        "Constant relocation and travel demands",
        "High risk of injury from equipment used"
      ],
      correctAnswer: 0
    },
    {
      id: 90586,
      question: "What type of work is involved in the Dental Laboratory Work alternative practice setting?",
      options: [
        "Writing scientific papers for journals",
        "Product testing and fabrication of oral products",
        "Managing insurance claims processing tasks",
        "Conducting oral health assessments in schools"
      ],
      correctAnswer: 1
    },
    {
      id: 90587,
      question: "What is listed as a possible downside of working for a Staff Placement Agency?",
      options: [
        "Extremely stressful travel requirements",
        "Low pay compared to other settings",
        "No clinical work and no client interaction",
        "Lack of local career opportunities available"
      ],
      correctAnswer: 2
    },
    {
      id: 90588,
      question: "Which area of law is mentioned as relevant to the Law and Dental Hygiene setting?",
      options: [
        "Criminal law and immigration law practice",
        "Tax law and corporate law practice",
        "Family law and property law practice",
        "Health law and professional negligence cases"
      ],
      correctAnswer: 3
    },
    {
      id: 90589,
      question: "What is an upside of working in Government Regulation and Policy?",
      options: [
        "Ability to work on issues at the macro level",
        "Guaranteed maintenance of clinical skills",
        "High commission-based earning potential",
        "Frequent international travel opportunities offered"
      ],
      correctAnswer: 0
    },
    {
      id: 90590,
      question: "What is a possible downside of working in Consumer Advocacy?",
      options: [
        "Complete lack of organizational skill requirements",
        "Job security would be extremely hard to obtain",
        "Excessive government oversight and red tape",
        "No opportunity to help the general population"
      ],
      correctAnswer: 1
    },
    {
      id: 90591,
      question: "Which activity is associated with being a \"Change Agent\" in dental hygiene?",
      options: [
        "Fabricating dental restorations and implants directly",
        "Writing children's books about oral health topics",
        "Lobbying and serving as an expert witness",
        "Managing hospital dental clinics directly onsite"
      ],
      correctAnswer: 2
    },
    {
      id: 90592,
      question: "What is a possible downside of Volunteering as an alternative practice setting?",
      options: [
        "It offers no opportunity to travel abroad",
        "It provides no experience in teamwork skills",
        "It prevents interaction with underprivileged people",
        "It usually requires self-financing or part-time income"
      ],
      correctAnswer: 3
    },
    {
      id: 90593,
      question: "According to the module, which article is described as providing \"a vital guide to non-traditional jobs\"?",
      options: [
        "\"Alternative Practice\" by Melinda Ferguson",
        "\"Evolution, Not Revolution\" by Fran Richardson",
        "\"From Clinic to Desk\" by Angela Best",
        "\"Entrepreneurship\" by Pat Spencer"
      ],
      correctAnswer: 0
    },
    {
      id: 90594,
      question: "What does the quoted excerpt from D.W. Lewis's article suggest about where most self-initiated dental hygiene care would be provided?",
      options: [
        "Only within traditional dental offices nationwide",
        "Alternative settings such as long-term care and community centres",
        "Exclusively within hospital pediatric departments",
        "Only in provinces without dental hygiene regulation"
      ],
      correctAnswer: 1
    },
    {
      id: 90595,
      question: "What is the main focus of Fran Richardson's article \"Evolution, Not Revolution\"?",
      options: [
        "Sales techniques for dental product companies",
        "Fabrication methods for dental laboratory products",
        "Self-regulation and an expanded, independent role for the profession",
        "Government policy on health insurance claims"
      ],
      correctAnswer: 2
    },
    {
      id: 90596,
      question: "Which CDHA document is mentioned as containing information on different practice environments and practice standards?",
      options: [
        "Employment Statistics and Trends",
        "The Political Economy of Dental Hygiene in Canada",
        "Healthy Mouth ~ Healthy Body",
        "Dental Hygiene: Definition, Scope and Practice Standards"
      ],
      correctAnswer: 3
    },
    {
      id: 90597,
      question: "True or False: According to the module, the goal of independent practice is to have dental hygienists work in isolation from dentists and other health providers.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 90598,
      question: "True or False: The National Defence/Canadian Forces setting is described as offering a strong emphasis on continuing education and standardized care regardless of location.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 90599,
      question: "True or False: The module states that self-employed contract dental hygienists receive the same statutory holiday and vacation pay benefits as employees.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ]
};
